// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-icon {
  background-color: #ecaa1e;
  font-size: medium;
  font-weight: bold;
  font-family: sans-serif;
  border-radius: 50%;
  color: #001e60;
  position: absolute;
  right: -10px;
  top: -12px;
  width: 20px;
  height: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.red-notification-icon {
  background-color: #ff3939;
  font-size: medium;
  font-weight: bold;
  font-family: sans-serif;
  border-radius: 50%;
  color: #001e60;
  position: absolute;
  right: -4px;
  top: -8px;
  width: 20px;
  height: 20px;
}

.relative-container {
  position: relative;
}

.hidden {
  display: none;
  visibility: hidden;
}

.position-left {
  left: -4px;
}

.blue-container {
  background-color: #00468d;
  color: white;
  border-radius: 8px;
  padding: 8px;
  text-align: center;
  transition: 300ms ease;
}

.blue-container:hover {
  background-color: var(--dark-secondary-color);
}

.hoverable-blue-container {
  background-color: #00468d;
  color: white;
  border-radius: 8px;
  padding: 8px;
  text-align: center;
}

.hoverable-blue-container:hover {
  background-color: #001e60;
}

.dark-blue-container {
  background-color: #001e60;
  color: white;
  border-radius: 8px;
  padding: 8px;
  text-align: center;
}

.blue-container > p {
  font-size: 100%;
}

.dark-blue-container-with-border {
  background: #001e60;
  border-color: #ecaa1e;
  border-radius: 8px;
  border-style: solid;
  border-width: 1px;
  margin: 0px 10px;
}

.fadeIn
{
  animation: fadeIn 0.5s;
}

.fadeInFast
{
  animation: fadeIn 0.25s;
}

.toggleButton{
  background-color: var(--primary-color);
  width: 40px;
  height: 20px;
  border-radius: 200px;
  cursor: pointer;
  position: relative;
  transition: 0.3s ease;
  border-width: 1px;
  border-color: white;
}

.toggleButton::before{
  position: absolute;
  content: '';
  background-color: #fff;
  width: 16px;
  height: 16px;
  margin: 1px;
  border-radius: 200px;
  transition: 0.3s ease;
}

.toggleInput:checked + .toggleButton{
  background-color: var(--accent-color);
}

.toggleInput:checked + .toggleButton::before{
  transform: translateX(20px);
}

.toggleInput{
  display: none;
}

/*
! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box;
  /* 1 */
  border-width: 0;
  /* 2 */
  border-style: solid;
  /* 2 */
  border-color: #e5e7eb;
  /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
  -moz-tab-size: 4;
  /* 3 */
  -o-tab-size: 4;
     tab-size: 4;
  /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  /* 4 */
  font-feature-settings: normal;
  /* 5 */
  font-variation-settings: normal;
  /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0;
  /* 1 */
  line-height: inherit;
  /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0;
  /* 1 */
  color: inherit;
  /* 2 */
  border-top-width: 1px;
  /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0;
  /* 1 */
  border-color: inherit;
  /* 2 */
  border-collapse: collapse;
  /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  /* 1 */
  font-feature-settings: inherit;
  /* 1 */
  font-variation-settings: inherit;
  /* 1 */
  font-size: 100%;
  /* 1 */
  font-weight: inherit;
  /* 1 */
  line-height: inherit;
  /* 1 */
  color: inherit;
  /* 1 */
  margin: 0;
  /* 2 */
  padding: 0;
  /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button;
  /* 1 */
  background-color: transparent;
  /* 2 */
  background-image: none;
  /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block;
  /* 1 */
  vertical-align: middle;
  /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

.pointer-events-none {
  pointer-events: none;
}

.invisible {
  visibility: hidden;
}

.fixed {
  position: fixed;
}

.absolute {
  position: absolute;
}

.relative {
  position: relative;
}

.inset-0 {
  inset: 0px;
}

.-left-2 {
  left: -0.5rem;
}

.bottom-10 {
  bottom: 2.5rem;
}

.bottom-\\[-155px\\] {
  bottom: -155px;
}

.bottom-\\[15\\%\\] {
  bottom: 15%;
}

.bottom-\\[5\\%\\] {
  bottom: 5%;
}

.bottom-\\[50\\%\\] {
  bottom: 50%;
}

.bottom-\\[55\\%\\] {
  bottom: 55%;
}

.left-0 {
  left: 0px;
}

.left-1\\/2 {
  left: 50%;
}

.left-5 {
  left: 1.25rem;
}

.left-7 {
  left: 1.75rem;
}

.left-\\[-100px\\] {
  left: -100px;
}

.left-\\[24px\\] {
  left: 24px;
}

.left-\\[380px\\] {
  left: 380px;
}

.left-\\[40vw\\] {
  left: 40vw;
}

.left-\\[5\\%\\] {
  left: 5%;
}

.left-\\[50vw\\] {
  left: 50vw;
}

.right-0 {
  right: 0px;
}

.right-3 {
  right: 0.75rem;
}

.right-\\[46\\%\\] {
  right: 46%;
}

.right-\\[50\\%\\] {
  right: 50%;
}

.top-0 {
  top: 0px;
}

.top-10 {
  top: 2.5rem;
}

.top-16 {
  top: 4rem;
}

.top-2 {
  top: 0.5rem;
}

.top-3 {
  top: 0.75rem;
}

.top-4 {
  top: 1rem;
}

.top-\\[15px\\] {
  top: 15px;
}

.top-\\[15vh\\] {
  top: 15vh;
}

.top-\\[80px\\] {
  top: 80px;
}

.z-10 {
  z-index: 10;
}

.z-30 {
  z-index: 30;
}

.z-50 {
  z-index: 50;
}

.z-\\[-1\\] {
  z-index: -1;
}

.z-\\[100\\] {
  z-index: 100;
}

.z-\\[101\\] {
  z-index: 101;
}

.z-\\[99\\] {
  z-index: 99;
}

.float-left {
  float: left;
}

.m-8 {
  margin: 2rem;
}

.mx-\\[10vw\\] {
  margin-left: 10vw;
  margin-right: 10vw;
}

.mx-\\[12\\%\\] {
  margin-left: 12%;
  margin-right: 12%;
}

.mx-\\[15px\\] {
  margin-left: 15px;
  margin-right: 15px;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.my-\\[14px\\] {
  margin-top: 14px;
  margin-bottom: 14px;
}

.my-\\[20px\\] {
  margin-top: 20px;
  margin-bottom: 20px;
}

.mb-1 {
  margin-bottom: 0.25rem;
}

.mb-10 {
  margin-bottom: 2.5rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-20 {
  margin-bottom: 5rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mb-5 {
  margin-bottom: 1.25rem;
}

.mb-\\[100px\\] {
  margin-bottom: 100px;
}

.mb-\\[10px\\] {
  margin-bottom: 10px;
}

.mb-\\[15px\\] {
  margin-bottom: 15px;
}

.mb-\\[20px\\] {
  margin-bottom: 20px;
}

.mb-\\[30px\\] {
  margin-bottom: 30px;
}

.mb-\\[40px\\] {
  margin-bottom: 40px;
}

.mb-\\[5px\\] {
  margin-bottom: 5px;
}

.mb-\\[60px\\] {
  margin-bottom: 60px;
}

.ml-8 {
  margin-left: 2rem;
}

.ml-auto {
  margin-left: auto;
}

.mr-0 {
  margin-right: 0px;
}

.mr-3 {
  margin-right: 0.75rem;
}

.mr-\\[10px\\] {
  margin-right: 10px;
}

.mr-\\[12px\\] {
  margin-right: 12px;
}

.mr-\\[30px\\] {
  margin-right: 30px;
}

.mr-auto {
  margin-right: auto;
}

.mt-10 {
  margin-top: 2.5rem;
}

.mt-12 {
  margin-top: 3rem;
}

.mt-16 {
  margin-top: 4rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mt-28 {
  margin-top: 7rem;
}

.mt-3 {
  margin-top: 0.75rem;
}

.mt-4 {
  margin-top: 1rem;
}

.mt-6 {
  margin-top: 1.5rem;
}

.mt-\\[10px\\] {
  margin-top: 10px;
}

.mt-\\[20px\\] {
  margin-top: 20px;
}

.mt-\\[40px\\] {
  margin-top: 40px;
}

.mt-\\[50px\\] {
  margin-top: 50px;
}

.mt-\\[66px\\] {
  margin-top: 66px;
}

.box-border {
  box-sizing: border-box;
}

.flex {
  display: flex;
}

.grid {
  display: grid;
}

.hidden {
  display: none;
}

.h-0 {
  height: 0px;
}

.h-10 {
  height: 2.5rem;
}

.h-14 {
  height: 3.5rem;
}

.h-20 {
  height: 5rem;
}

.h-24 {
  height: 6rem;
}

.h-32 {
  height: 8rem;
}

.h-36 {
  height: 9rem;
}

.h-6 {
  height: 1.5rem;
}

.h-8 {
  height: 2rem;
}

.h-\\[100\\%\\] {
  height: 100%;
}

.h-\\[100px\\] {
  height: 100px;
}

.h-\\[100vh\\] {
  height: 100vh;
}

.h-\\[126px\\] {
  height: 126px;
}

.h-\\[155px\\] {
  height: 155px;
}

.h-\\[30px\\] {
  height: 30px;
}

.h-\\[40px\\] {
  height: 40px;
}

.h-\\[50px\\] {
  height: 50px;
}

.h-\\[50vh\\] {
  height: 50vh;
}

.h-\\[60vh\\] {
  height: 60vh;
}

.h-\\[80vh\\] {
  height: 80vh;
}

.h-\\[82px\\] {
  height: 82px;
}

.h-\\[85px\\] {
  height: 85px;
}

.h-\\[89px\\] {
  height: 89px;
}

.h-\\[90vh\\] {
  height: 90vh;
}

.h-full {
  height: 100%;
}

.max-h-0 {
  max-height: 0px;
}

.max-h-\\[100\\%\\] {
  max-height: 100%;
}

.max-h-\\[100vh\\] {
  max-height: 100vh;
}

.max-h-\\[101px\\] {
  max-height: 101px;
}

.max-h-\\[200px\\] {
  max-height: 200px;
}

.max-h-\\[52px\\] {
  max-height: 52px;
}

.min-h-\\[201px\\] {
  min-height: 201px;
}

.min-h-full {
  min-height: 100%;
}

.min-h-screen {
  min-height: 100vh;
}

.w-0 {
  width: 0px;
}

.w-10 {
  width: 2.5rem;
}

.w-14 {
  width: 3.5rem;
}

.w-24 {
  width: 6rem;
}

.w-6 {
  width: 1.5rem;
}

.w-64 {
  width: 16rem;
}

.w-80 {
  width: 20rem;
}

.w-\\[100\\%\\] {
  width: 100%;
}

.w-\\[100px\\] {
  width: 100px;
}

.w-\\[100vw\\] {
  width: 100vw;
}

.w-\\[112\\.766px\\] {
  width: 112.766px;
}

.w-\\[113px\\] {
  width: 113px;
}

.w-\\[1600px\\] {
  width: 1600px;
}

.w-\\[165px\\] {
  width: 165px;
}

.w-\\[210px\\] {
  width: 210px;
}

.w-\\[220px\\] {
  width: 220px;
}

.w-\\[25\\%\\] {
  width: 25%;
}

.w-\\[30\\%\\] {
  width: 30%;
}

.w-\\[30px\\] {
  width: 30px;
}

.w-\\[332px\\] {
  width: 332px;
}

.w-\\[341px\\] {
  width: 341px;
}

.w-\\[380px\\] {
  width: 380px;
}

.w-\\[40px\\] {
  width: 40px;
}

.w-\\[50\\%\\] {
  width: 50%;
}

.w-\\[50px\\] {
  width: 50px;
}

.w-\\[60\\%\\] {
  width: 60%;
}

.w-\\[60px\\] {
  width: 60px;
}

.w-\\[60vw\\] {
  width: 60vw;
}

.w-\\[70\\%\\] {
  width: 70%;
}

.w-\\[75\\%\\] {
  width: 75%;
}

.w-\\[80\\%\\] {
  width: 80%;
}

.w-\\[82px\\] {
  width: 82px;
}

.w-\\[85px\\] {
  width: 85px;
}

.w-\\[90\\%\\] {
  width: 90%;
}

.w-\\[90px\\] {
  width: 90px;
}

.w-\\[95\\%\\] {
  width: 95%;
}

.w-full {
  width: 100%;
}

.min-w-\\[100vw\\] {
  min-width: 100vw;
}

.min-w-\\[380px\\] {
  min-width: 380px;
}

.max-w-\\[100\\%\\] {
  max-width: 100%;
}

.max-w-\\[1200px\\] {
  max-width: 1200px;
}

.max-w-\\[1600px\\] {
  max-width: 1600px;
}

.max-w-\\[300px\\] {
  max-width: 300px;
}

.max-w-\\[35\\%\\] {
  max-width: 35%;
}

.max-w-\\[40\\%\\] {
  max-width: 40%;
}

.max-w-\\[70\\%\\] {
  max-width: 70%;
}

.flex-1 {
  flex: 1 1 0%;
}

.flex-shrink-0 {
  flex-shrink: 0;
}

.flex-grow {
  flex-grow: 1;
}

.origin-top {
  transform-origin: top;
}

.translate-x-\\[-50\\%\\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes ali-fill {
  0% {
    transform: scaleY(0);
  }

  25% {
    transform: scaleY(0);
  }

  50% {
    transform: scaleY(1);
  }

  75% {
    transform: scaleY(1);
  }

  100% {
    transform: scaleY(0);
  }
}

.animate-ali-fill {
  animation: ali-fill 2s infinite ease-in;
}

@keyframes ali-spin {
  0% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(180deg);
  }

  50% {
    transform: rotate(180deg);
  }

  75% {
    transform: rotate(360deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.animate-ali-spin {
  animation: ali-spin 2s infinite ease;
}

.cursor-pointer {
  cursor: pointer;
}

.select-none {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.resize-none {
  resize: none;
}

.resize {
  resize: both;
}

.appearance-none {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}

.auto-cols-auto {
  grid-auto-columns: auto;
}

.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.flex-row {
  flex-direction: row;
}

.flex-col {
  flex-direction: column;
}

.flex-col-reverse {
  flex-direction: column-reverse;
}

.flex-wrap {
  flex-wrap: wrap;
}

.content-center {
  align-content: center;
}

.items-start {
  align-items: flex-start;
}

.items-end {
  align-items: flex-end;
}

.items-center {
  align-items: center;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-evenly {
  justify-content: space-evenly;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-3 {
  gap: 0.75rem;
}

.gap-4 {
  gap: 1rem;
}

.gap-5 {
  gap: 1.25rem;
}

.gap-6 {
  gap: 1.5rem;
}

.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}

.overflow-auto {
  overflow: auto;
}

.overflow-hidden {
  overflow: hidden;
}

.overflow-scroll {
  overflow: scroll;
}

.overflow-y-auto {
  overflow-y: auto;
}

.overflow-x-hidden {
  overflow-x: hidden;
}

.overflow-y-hidden {
  overflow-y: hidden;
}

.overflow-y-scroll {
  overflow-y: scroll;
}

.overflow-ellipsis {
  text-overflow: ellipsis;
}

.whitespace-normal {
  white-space: normal;
}

.whitespace-nowrap {
  white-space: nowrap;
}

.break-words {
  overflow-wrap: break-word;
}

.rounded {
  border-radius: 0.25rem;
}

.rounded-2xl {
  border-radius: 1rem;
}

.rounded-3xl {
  border-radius: 1.5rem;
}

.rounded-\\[10px\\] {
  border-radius: 10px;
}

.rounded-\\[15px\\] {
  border-radius: 15px;
}

.rounded-\\[20px\\] {
  border-radius: 20px;
}

.rounded-\\[50\\%\\] {
  border-radius: 50%;
}

.rounded-full {
  border-radius: 9999px;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.rounded-md {
  border-radius: 0.375rem;
}

.rounded-xl {
  border-radius: 0.75rem;
}

.rounded-b-\\[15px\\] {
  border-bottom-right-radius: 15px;
  border-bottom-left-radius: 15px;
}

.rounded-t-\\[15px\\] {
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.border {
  border-width: 1px;
}

.border-2 {
  border-width: 2px;
}

.border-\\[1\\.5px\\] {
  border-width: 1.5px;
}

.border-\\[4px\\] {
  border-width: 4px;
}

.border-y-0 {
  border-top-width: 0px;
  border-bottom-width: 0px;
}

.border-b-2 {
  border-bottom-width: 2px;
}

.border-r-2 {
  border-right-width: 2px;
}

.border-t-2 {
  border-top-width: 2px;
}

.border-none {
  border-style: none;
}

.border-ali-backgroundblue {
  --tw-border-opacity: 1;
  border-color: rgb(0 150 201 / var(--tw-border-opacity));
}

.border-ali-darkblue {
  --tw-border-opacity: 1;
  border-color: rgb(0 30 96 / var(--tw-border-opacity));
}

.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.border-y-ali-darkblue {
  --tw-border-opacity: 1;
  border-top-color: rgb(0 30 96 / var(--tw-border-opacity));
  border-bottom-color: rgb(0 30 96 / var(--tw-border-opacity));
}

.border-r-ali-backgroundblue {
  --tw-border-opacity: 1;
  border-right-color: rgb(0 150 201 / var(--tw-border-opacity));
}

.border-opacity-50 {
  --tw-border-opacity: 0.5;
}

.bg-\\[\\#001A52\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 26 82 / var(--tw-bg-opacity));
}

.bg-\\[\\#001E60\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 30 96 / var(--tw-bg-opacity));
}

.bg-\\[\\#00468D\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 70 141 / var(--tw-bg-opacity));
}

.bg-\\[\\#2C6BAC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(44 107 172 / var(--tw-bg-opacity));
}

.bg-\\[\\#C5C5C5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(197 197 197 / var(--tw-bg-opacity));
}

.bg-\\[\\#D9D9D9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity));
}

.bg-\\[\\#ECAA1E\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(236 170 30 / var(--tw-bg-opacity));
}

.bg-\\[\\#EDEDED\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(237 237 237 / var(--tw-bg-opacity));
}

.bg-\\[\\#F5F5F5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}

.bg-\\[\\#FFFFFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.bg-\\[color\\:var\\(--secondary-color\\)\\] {
  background-color: var(--secondary-color);
}

.bg-ali-backgroundblue {
  --tw-bg-opacity: 1;
  background-color: rgb(0 150 201 / var(--tw-bg-opacity));
}

.bg-ali-darkblue {
  --tw-bg-opacity: 1;
  background-color: rgb(0 30 96 / var(--tw-bg-opacity));
}

.bg-ali-lightblue {
  --tw-bg-opacity: 1;
  background-color: rgb(0 70 141 / var(--tw-bg-opacity));
}

.bg-ali-orange {
  --tw-bg-opacity: 1;
  background-color: rgb(236 170 30 / var(--tw-bg-opacity));
}

.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}

.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}

.bg-slate-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity));
}

.bg-transparent {
  background-color: transparent;
}

.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity));
}

.object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}

.p-1 {
  padding: 0.25rem;
}

.p-2 {
  padding: 0.5rem;
}

.p-4 {
  padding: 1rem;
}

.p-6 {
  padding: 1.5rem;
}

.p-8 {
  padding: 2rem;
}

.p-\\[15px\\] {
  padding: 15px;
}

.p-\\[25px\\] {
  padding: 25px;
}

.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}

.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}

.px-\\[10px\\] {
  padding-left: 10px;
  padding-right: 10px;
}

.px-\\[15px\\] {
  padding-left: 15px;
  padding-right: 15px;
}

.px-\\[24px\\] {
  padding-left: 24px;
  padding-right: 24px;
}

.px-\\[25px\\] {
  padding-left: 25px;
  padding-right: 25px;
}

.px-\\[30px\\] {
  padding-left: 30px;
  padding-right: 30px;
}

.px-\\[5\\%\\] {
  padding-left: 5%;
  padding-right: 5%;
}

.px-\\[50px\\] {
  padding-left: 50px;
  padding-right: 50px;
}

.px-\\[5px\\] {
  padding-left: 5px;
  padding-right: 5px;
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}

.py-\\[20px\\] {
  padding-top: 20px;
  padding-bottom: 20px;
}

.py-\\[40px\\] {
  padding-top: 40px;
  padding-bottom: 40px;
}

.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}

.pb-2 {
  padding-bottom: 0.5rem;
}

.pb-3 {
  padding-bottom: 0.75rem;
}

.pb-4 {
  padding-bottom: 1rem;
}

.pb-8 {
  padding-bottom: 2rem;
}

.pb-\\[100px\\] {
  padding-bottom: 100px;
}

.pb-\\[40px\\] {
  padding-bottom: 40px;
}

.pl-20 {
  padding-left: 5rem;
}

.pl-\\[125px\\] {
  padding-left: 125px;
}

.pr-2 {
  padding-right: 0.5rem;
}

.pt-2 {
  padding-top: 0.5rem;
}

.pt-2\\.5 {
  padding-top: 0.625rem;
}

.pt-4 {
  padding-top: 1rem;
}

.pt-5 {
  padding-top: 1.25rem;
}

.pt-\\[10px\\] {
  padding-top: 10px;
}

.pt-\\[20px\\] {
  padding-top: 20px;
}

.pt-\\[66px\\] {
  padding-top: 66px;
}

.pl-24 {
  padding-left: 6rem;
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}

.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}

.text-5xl {
  font-size: 3rem;
  line-height: 1;
}

.text-\\[110\\%\\] {
  font-size: 110%;
}

.text-\\[12px\\] {
  font-size: 12px;
}

.text-\\[130\\%\\] {
  font-size: 130%;
}

.text-\\[13px\\] {
  font-size: 13px;
}

.text-\\[140\\%\\] {
  font-size: 140%;
}

.text-\\[14px\\] {
  font-size: 14px;
}

.text-\\[18px\\] {
  font-size: 18px;
}

.text-\\[20px\\] {
  font-size: 20px;
}

.text-\\[28px\\] {
  font-size: 28px;
}

.text-\\[80\\%\\] {
  font-size: 80%;
}

.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}

.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}

.font-\\[400\\] {
  font-weight: 400;
}

.font-\\[500\\] {
  font-weight: 500;
}

.font-\\[600\\] {
  font-weight: 600;
}

.font-bold {
  font-weight: 700;
}

.font-medium {
  font-weight: 500;
}

.font-semibold {
  font-weight: 600;
}

.text-\\[\\#002347\\] {
  --tw-text-opacity: 1;
  color: rgb(0 35 71 / var(--tw-text-opacity));
}

.text-\\[\\#23F638\\] {
  --tw-text-opacity: 1;
  color: rgb(35 246 56 / var(--tw-text-opacity));
}

.text-\\[\\#465985\\] {
  --tw-text-opacity: 1;
  color: rgb(70 89 133 / var(--tw-text-opacity));
}

.text-\\[\\#FE2F2F\\] {
  --tw-text-opacity: 1;
  color: rgb(254 47 47 / var(--tw-text-opacity));
}

.text-\\[\\#ecaa1e\\] {
  --tw-text-opacity: 1;
  color: rgb(236 170 30 / var(--tw-text-opacity));
}

.text-\\[var\\(--accent-color\\)\\] {
  color: var(--accent-color);
}

.text-ali-darkblue {
  --tw-text-opacity: 1;
  color: rgb(0 30 96 / var(--tw-text-opacity));
}

.text-ali-orange {
  --tw-text-opacity: 1;
  color: rgb(236 170 30 / var(--tw-text-opacity));
}

.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.text-regal-blue {
  --tw-text-opacity: 1;
  color: rgb(36 60 90 / var(--tw-text-opacity));
}

.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.underline {
  text-decoration-line: underline;
}

.opacity-0 {
  opacity: 0;
}

.opacity-100 {
  opacity: 1;
}

.opacity-50 {
  opacity: 0.5;
}

.opacity-60 {
  opacity: 0.6;
}

.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.duration-300 {
  transition-duration: 300ms;
}

.duration-500 {
  transition-duration: 500ms;
}

.duration-\\[300ms\\] {
  transition-duration: 300ms;
}

.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

/* Hide scrollbar for Chrome, Safari and Opera */

/* Hide scrollbar for IE, Edge and Firefox */

.hover\\:scale-\\[1\\.1\\]:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:bg-\\[\\#00468D\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 70 141 / var(--tw-bg-opacity));
}

.hover\\:bg-\\[color\\:var\\(--dark-secondary-color\\)\\]:hover {
  background-color: var(--dark-secondary-color);
}

.hover\\:bg-\\[color\\:var\\(--secondary-color\\)\\]:hover {
  background-color: var(--secondary-color);
}

.hover\\:bg-ali-darkblue:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 30 96 / var(--tw-bg-opacity));
}

.hover\\:bg-ali-lightblue:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 70 141 / var(--tw-bg-opacity));
}

.hover\\:text-\\[color\\:var\\(--accent-color\\)\\]:hover {
  color: var(--accent-color);
}

.hover\\:text-\\[white\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

@media (max-width: 1250px) {
  .xxlr\\:mr-\\[0px\\] {
    margin-right: 0px;
  }

  .xxlr\\:w-\\[86\\%\\] {
    width: 86%;
  }

  .xxlr\\:max-w-\\[400px\\] {
    max-width: 400px;
  }

  .xxlr\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xxlr\\:text-start {
    text-align: start;
  }

  .xxlr\\:text-\\[120\\%\\] {
    font-size: 120%;
  }
}

@media (max-width: 1050px) {
  .xlr\\:h-\\[40px\\] {
    height: 40px;
  }

  .xlr\\:w-\\[180px\\] {
    width: 180px;
  }

  .xlr\\:w-\\[40px\\] {
    width: 40px;
  }

  .xlr\\:max-w-\\[300px\\] {
    max-width: 300px;
  }

  .xlr\\:max-w-\\[40\\%\\] {
    max-width: 40%;
  }

  .xlr\\:items-center {
    align-items: center;
  }

  .xlr\\:px-\\[20px\\] {
    padding-left: 20px;
    padding-right: 20px;
  }

  .xlr\\:text-\\[100\\%\\] {
    font-size: 100%;
  }

  .xlr\\:text-\\[110\\%\\] {
    font-size: 110%;
  }

  .xlr\\:text-\\[14px\\] {
    font-size: 14px;
  }
}

@media (max-width: 850px) {
  .lr\\:mt-24 {
    margin-top: 6rem;
  }

  .lr\\:mt-32 {
    margin-top: 8rem;
  }

  .lr\\:mt-\\[100px\\] {
    margin-top: 100px;
  }

  .lr\\:mt-\\[120px\\] {
    margin-top: 120px;
  }

  .lr\\:mt-\\[160px\\] {
    margin-top: 160px;
  }

  .lr\\:mt-\\[70px\\] {
    margin-top: 70px;
  }

  .lr\\:h-\\[100vh\\] {
    height: 100vh;
  }

  .lr\\:h-\\[30px\\] {
    height: 30px;
  }

  .lr\\:h-\\[35px\\] {
    height: 35px;
  }

  .lr\\:h-auto {
    height: auto;
  }

  .lr\\:w-\\[100vw\\] {
    width: 100vw;
  }

  .lr\\:w-\\[160px\\] {
    width: 160px;
  }

  .lr\\:w-\\[30px\\] {
    width: 30px;
  }

  .lr\\:w-\\[35px\\] {
    width: 35px;
  }

  .lr\\:w-\\[70px\\] {
    width: 70px;
  }

  .lr\\:w-\\[70vw\\] {
    width: 70vw;
  }

  .lr\\:w-\\[80\\%\\] {
    width: 80%;
  }

  .lr\\:w-\\[85\\%\\] {
    width: 85%;
  }

  .lr\\:w-\\[92\\%\\] {
    width: 92%;
  }

  .lr\\:max-w-\\[1000px\\] {
    max-width: 1000px;
  }

  .lr\\:scale-\\[1\\.0\\] {
    --tw-scale-x: 1.0;
    --tw-scale-y: 1.0;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lr\\:animate-none {
    animation: none;
  }

  .lr\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lr\\:flex-col {
    flex-direction: column;
  }

  .lr\\:items-center {
    align-items: center;
  }

  .lr\\:justify-end {
    justify-content: flex-end;
  }

  .lr\\:overflow-y-scroll {
    overflow-y: scroll;
  }

  .lr\\:border-r-0 {
    border-right-width: 0px;
  }

  .lr\\:p-\\[10px\\] {
    padding: 10px;
  }

  .lr\\:py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .lr\\:pb-\\[50px\\] {
    padding-bottom: 50px;
  }

  .lr\\:pt-\\[110px\\] {
    padding-top: 110px;
  }

  .lr\\:pt-\\[3rem\\] {
    padding-top: 3rem;
  }

  .lr\\:pt-\\[66px\\] {
    padding-top: 66px;
  }

  .lr\\:text-\\[100\\%\\] {
    font-size: 100%;
  }

  .lr\\:text-\\[12px\\] {
    font-size: 12px;
  }

  .lr\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .lr\\:text-\\[22px\\] {
    font-size: 22px;
  }

  .lr\\:text-\\[90\\%\\] {
    font-size: 90%;
  }
}

@media (max-width: 600px) {
  .md\\:absolute {
    position: absolute;
  }

  .md\\:top-0 {
    top: 0px;
  }

  .md\\:top-\\[15vh\\] {
    top: 15vh;
  }

  .md\\:ml-0 {
    margin-left: 0px;
  }

  .md\\:mt-32 {
    margin-top: 8rem;
  }

  .md\\:mt-\\[100px\\] {
    margin-top: 100px;
  }

  .md\\:mt-\\[10px\\] {
    margin-top: 10px;
  }

  .md\\:line-clamp-2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-\\[30px\\] {
    height: 30px;
  }

  .md\\:h-\\[65vh\\] {
    height: 65vh;
  }

  .md\\:w-\\[100\\%\\] {
    width: 100%;
  }

  .md\\:w-\\[30px\\] {
    width: 30px;
  }

  .md\\:w-\\[80vw\\] {
    width: 80vw;
  }

  .md\\:w-\\[95\\%\\] {
    width: 95%;
  }

  .md\\:scale-\\[0\\.9\\] {
    --tw-scale-x: 0.9;
    --tw-scale-y: 0.9;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .md\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .md\\:items-start {
    align-items: flex-start;
  }

  .md\\:justify-end {
    justify-content: flex-end;
  }

  .md\\:justify-center {
    justify-content: center;
  }

  .md\\:px-\\[10px\\] {
    padding-left: 10px;
    padding-right: 10px;
  }

  .md\\:py-\\[10px\\] {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .md\\:pt-0 {
    padding-top: 0px;
  }

  .md\\:text-center {
    text-align: center;
  }

  .md\\:text-\\[12px\\] {
    font-size: 12px;
  }

  .md\\:text-\\[13px\\] {
    font-size: 13px;
  }

  .md\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .md\\:text-\\[16px\\] {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .sm\\:mx-\\[20px\\] {
    margin-left: 20px;
    margin-right: 20px;
  }

  .sm\\:mb-1 {
    margin-bottom: 0.25rem;
  }

  .sm\\:mb-\\[30px\\] {
    margin-bottom: 30px;
  }

  .sm\\:mt-\\[140px\\] {
    margin-top: 140px;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-\\[100px\\] {
    height: 100px;
  }

  .sm\\:h-\\[20px\\] {
    height: 20px;
  }

  .sm\\:h-\\[60px\\] {
    height: 60px;
  }

  .sm\\:w-\\[130px\\] {
    width: 130px;
  }

  .sm\\:w-\\[20px\\] {
    width: 20px;
  }

  .sm\\:w-\\[50px\\] {
    width: 50px;
  }

  .sm\\:w-\\[90\\%\\] {
    width: 90%;
  }

  .sm\\:w-\\[90vw\\] {
    width: 90vw;
  }

  .sm\\:scale-\\[0\\.8\\] {
    --tw-scale-x: 0.8;
    --tw-scale-y: 0.8;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:justify-around {
    justify-content: space-around;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:p-\\[5px\\] {
    padding: 5px;
  }

  .sm\\:px-\\[10px\\] {
    padding-left: 10px;
    padding-right: 10px;
  }

  .sm\\:pt-\\[0px\\] {
    padding-top: 0px;
  }

  .sm\\:text-\\[12px\\] {
    font-size: 12px;
  }

  .sm\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .sm\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .sm\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .sm\\:text-\\[70\\%\\] {
    font-size: 70%;
  }

  .sm\\:text-\\[80\\%\\] {
    font-size: 80%;
  }

  .sm\\:text-\\[85\\%\\] {
    font-size: 85%;
  }
}

@media (max-width: 350px) {
  .xsm\\:w-\\[100px\\] {
    width: 100px;
  }

  .xsm\\:w-\\[200px\\] {
    width: 200px;
  }

  .xsm\\:w-\\[95\\%\\] {
    width: 95%;
  }

  .xsm\\:scale-\\[0\\.7\\] {
    --tw-scale-x: 0.7;
    --tw-scale-y: 0.7;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .xsm\\:pt-\\[10px\\] {
    padding-top: 10px;
  }

  .xsm\\:text-\\[11px\\] {
    font-size: 11px;
  }

  .xsm\\:text-\\[60\\%\\] {
    font-size: 60%;
  }

  .xsm\\:text-\\[70\\%\\] {
    font-size: 70%;
  }

  .xsm\\:text-\\[80\\%\\] {
    font-size: 80%;
  }
}

@media (min-width: 480px) {
  .mdd\\:hidden {
    display: none;
  }
}

@media (min-width: 600px) {
  .lrr\\:mt-0 {
    margin-top: 0px;
  }

  .lrr\\:hidden {
    display: none;
  }
}

@media (min-width: 850px) {
  .xlrr\\:fixed {
    position: fixed;
  }

  .xlrr\\:hidden {
    display: none;
  }
}

@media (min-width: 414px) {
  .txsm\\:top-10 {
    top: 2.5rem;
  }

  .txsm\\:top-6 {
    top: 1.5rem;
  }

  .txsm\\:h-\\[0px\\] {
    height: 0px;
  }

  .txsm\\:h-\\[150px\\] {
    height: 150px;
  }

  .txsm\\:h-\\[300px\\] {
    height: 300px;
  }
}

@media (min-width: 600px) {
  .tsm\\:h-36 {
    height: 9rem;
  }

  .tsm\\:h-\\[180px\\] {
    height: 180px;
  }

  .tsm\\:h-\\[230px\\] {
    height: 230px;
  }

  .tsm\\:h-\\[275px\\] {
    height: 275px;
  }

  .tsm\\:h-\\[300px\\] {
    height: 300px;
  }

  .tsm\\:h-\\[350px\\] {
    height: 350px;
  }

  .tsm\\:w-72 {
    width: 18rem;
  }

  .tsm\\:w-\\[90\\%\\] {
    width: 90%;
  }

  .tsm\\:flex-row {
    flex-direction: row;
  }

  .tsm\\:items-center {
    align-items: center;
  }

  .tsm\\:justify-center {
    justify-content: center;
  }

  .tsm\\:gap-10 {
    gap: 2.5rem;
  }
}

@media (min-width: 780px) {
  .tmd\\:absolute {
    position: absolute;
  }

  .tmd\\:left-20 {
    left: 5rem;
  }

  .tmd\\:left-4 {
    left: 1rem;
  }

  .tmd\\:top-8 {
    top: 2rem;
  }

  .tmd\\:top-\\[24px\\] {
    top: 24px;
  }

  .tmd\\:mt-0 {
    margin-top: 0px;
  }

  .tmd\\:h-44 {
    height: 11rem;
  }

  .tmd\\:h-\\[175px\\] {
    height: 175px;
  }

  .tmd\\:h-\\[200px\\] {
    height: 200px;
  }

  .tmd\\:h-\\[250px\\] {
    height: 250px;
  }

  .tmd\\:h-\\[260px\\] {
    height: 260px;
  }

  .tmd\\:h-\\[335px\\] {
    height: 335px;
  }

  .tmd\\:h-28 {
    height: 7rem;
  }

  .tmd\\:w-80 {
    width: 20rem;
  }

  .tmd\\:w-28 {
    width: 7rem;
  }

  .tmd\\:gap-20 {
    gap: 5rem;
  }
}

@media (min-width: 1024px) {
  .tlg\\:absolute {
    position: absolute;
  }

  .tlg\\:left-36 {
    left: 9rem;
  }

  .tlg\\:top-8 {
    top: 2rem;
  }

  .tlg\\:top-\\[35px\\] {
    top: 35px;
  }

  .tlg\\:left-32 {
    left: 8rem;
  }

  .tlg\\:top-\\[24px\\] {
    top: 24px;
  }

  .tlg\\:mt-0 {
    margin-top: 0px;
  }

  .tlg\\:mt-20 {
    margin-top: 5rem;
  }

  .tlg\\:mt-24 {
    margin-top: 6rem;
  }

  .tlg\\:flex {
    display: flex;
  }

  .tlg\\:h-14 {
    height: 3.5rem;
  }

  .tlg\\:h-44 {
    height: 11rem;
  }

  .tlg\\:h-\\[130px\\] {
    height: 130px;
  }

  .tlg\\:h-\\[170px\\] {
    height: 170px;
  }

  .tlg\\:h-\\[176px\\] {
    height: 176px;
  }

  .tlg\\:h-16 {
    height: 4rem;
  }

  .tlg\\:h-32 {
    height: 8rem;
  }

  .tlg\\:h-52 {
    height: 13rem;
  }

  .tlg\\:w-14 {
    width: 3.5rem;
  }

  .tlg\\:w-80 {
    width: 20rem;
  }

  .tlg\\:w-\\[70\\%\\] {
    width: 70%;
  }

  .tlg\\:w-\\[80\\%\\] {
    width: 80%;
  }

  .tlg\\:w-16 {
    width: 4rem;
  }

  .tlg\\:w-32 {
    width: 8rem;
  }

  .tlg\\:w-\\[430px\\] {
    width: 430px;
  }

  .tlg\\:w-\\[439px\\] {
    width: 439px;
  }

  .tlg\\:w-\\[90\\%\\] {
    width: 90%;
  }

  .tlg\\:flex-row {
    flex-direction: row;
  }

  .tlg\\:items-center {
    align-items: center;
  }

  .tlg\\:justify-center {
    justify-content: center;
  }

  .tlg\\:gap-20 {
    gap: 5rem;
  }

  .tlg\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

@media (min-width: 1280px) {
  .txl\\:absolute {
    position: absolute;
  }

  .txl\\:left-40 {
    left: 10rem;
  }

  .txl\\:top-8 {
    top: 2rem;
  }

  .txl\\:top-\\[35px\\] {
    top: 35px;
  }

  .txl\\:left-36 {
    left: 9rem;
  }

  .txl\\:top-\\[24px\\] {
    top: 24px;
  }

  .txl\\:mt-20 {
    margin-top: 5rem;
  }

  .txl\\:mt-24 {
    margin-top: 6rem;
  }

  .txl\\:h-44 {
    height: 11rem;
  }

  .txl\\:h-\\[120px\\] {
    height: 120px;
  }

  .txl\\:h-\\[150px\\] {
    height: 150px;
  }

  .txl\\:h-\\[230px\\] {
    height: 230px;
  }

  .txl\\:h-\\[250px\\] {
    height: 250px;
  }

  .txl\\:h-\\[260px\\] {
    height: 260px;
  }

  .txl\\:h-52 {
    height: 13rem;
  }

  .txl\\:w-96 {
    width: 24rem;
  }

  .txl\\:w-\\[70\\%\\] {
    width: 70%;
  }

  .txl\\:w-\\[450px\\] {
    width: 450px;
  }

  .txl\\:gap-48 {
    gap: 12rem;
  }

  .txl\\:gap-20 {
    gap: 5rem;
  }
}

@media (min-width: 1536px) {
  .t2xl\\:absolute {
    position: absolute;
  }

  .t2xl\\:left-52 {
    left: 13rem;
  }

  .t2xl\\:top-8 {
    top: 2rem;
  }

  .t2xl\\:left-48 {
    left: 12rem;
  }

  .t2xl\\:top-\\[24px\\] {
    top: 24px;
  }

  .t2xl\\:mt-20 {
    margin-top: 5rem;
  }

  .t2xl\\:mt-32 {
    margin-top: 8rem;
  }

  .t2xl\\:h-\\[130px\\] {
    height: 130px;
  }

  .t2xl\\:h-\\[150px\\] {
    height: 150px;
  }

  .t2xl\\:h-\\[180px\\] {
    height: 180px;
  }

  .t2xl\\:h-\\[190px\\] {
    height: 190px;
  }

  .t2xl\\:h-\\[200px\\] {
    height: 200px;
  }

  .t2xl\\:h-\\[350px\\] {
    height: 350px;
  }

  .t2xl\\:h-60 {
    height: 15rem;
  }

  .t2xl\\:h-\\[400px\\] {
    height: 400px;
  }

  .t2xl\\:h-\\[550px\\] {
    height: 550px;
  }

  .t2xl\\:w-\\[70\\%\\] {
    width: 70%;
  }

  .t2xl\\:w-\\[80\\%\\] {
    width: 80%;
  }

  .t2xl\\:w-\\[550px\\] {
    width: 550px;
  }

  .t2xl\\:w-\\[90\\%\\] {
    width: 90%;
  }

  .t2xl\\:justify-center {
    justify-content: center;
  }

  .t2xl\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

@media (min-width: 2570px) {
  .t3xl\\:absolute {
    position: absolute;
  }

  .t3xl\\:left-52 {
    left: 13rem;
  }

  .t3xl\\:left-96 {
    left: 24rem;
  }

  .t3xl\\:top-8 {
    top: 2rem;
  }

  .t3xl\\:top-\\[100px\\] {
    top: 100px;
  }

  .t3xl\\:top-\\[108px\\] {
    top: 108px;
  }

  .t3xl\\:top-\\[80px\\] {
    top: 80px;
  }

  .t3xl\\:left-\\[8\\%\\] {
    left: 8%;
  }

  .t3xl\\:top-\\[52px\\] {
    top: 52px;
  }

  .t3xl\\:mb-4 {
    margin-bottom: 1rem;
  }

  .t3xl\\:ml-4 {
    margin-left: 1rem;
  }

  .t3xl\\:ml-40 {
    margin-left: 10rem;
  }

  .t3xl\\:mt-10 {
    margin-top: 2.5rem;
  }

  .t3xl\\:mt-16 {
    margin-top: 4rem;
  }

  .t3xl\\:mt-2 {
    margin-top: 0.5rem;
  }

  .t3xl\\:mt-4 {
    margin-top: 1rem;
  }

  .t3xl\\:mt-6 {
    margin-top: 1.5rem;
  }

  .t3xl\\:mt-8 {
    margin-top: 2rem;
  }

  .t3xl\\:mb-12 {
    margin-bottom: 3rem;
  }

  .t3xl\\:mt-24 {
    margin-top: 6rem;
  }

  .t3xl\\:mt-44 {
    margin-top: 11rem;
  }

  .t3xl\\:flex {
    display: flex;
  }

  .t3xl\\:h-20 {
    height: 5rem;
  }

  .t3xl\\:h-36 {
    height: 9rem;
  }

  .t3xl\\:h-52 {
    height: 13rem;
  }

  .t3xl\\:h-\\[280px\\] {
    height: 280px;
  }

  .t3xl\\:h-\\[300px\\] {
    height: 300px;
  }

  .t3xl\\:h-\\[400px\\] {
    height: 400px;
  }

  .t3xl\\:h-\\[420px\\] {
    height: 420px;
  }

  .t3xl\\:h-\\[450px\\] {
    height: 450px;
  }

  .t3xl\\:h-\\[500px\\] {
    height: 500px;
  }

  .t3xl\\:h-72 {
    height: 18rem;
  }

  .t3xl\\:max-h-\\[500px\\] {
    max-height: 500px;
  }

  .t3xl\\:w-36 {
    width: 9rem;
  }

  .t3xl\\:w-52 {
    width: 13rem;
  }

  .t3xl\\:w-\\[800px\\] {
    width: 800px;
  }

  .t3xl\\:w-72 {
    width: 18rem;
  }

  .t3xl\\:w-\\[1200px\\] {
    width: 1200px;
  }

  .t3xl\\:w-\\[75\\%\\] {
    width: 75%;
  }

  .t3xl\\:items-center {
    align-items: center;
  }

  .t3xl\\:justify-center {
    justify-content: center;
  }

  .t3xl\\:gap-56 {
    gap: 14rem;
  }

  .t3xl\\:gap-20 {
    gap: 5rem;
  }

  .t3xl\\:rounded-xl {
    border-radius: 0.75rem;
  }

  .t3xl\\:pl-60 {
    padding-left: 15rem;
  }

  .t3xl\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .t3xl\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .t3xl\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .t3xl\\:font-bold {
    font-weight: 700;
  }

  .t3xl\\:leading-normal {
    line-height: 1.5;
  }
}

`, "",{"version":3,"sources":["webpack://./public/stylesheets/style.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;;CAEC;;AAED;;;CAGC;;AAED;;;EAGE,sBAAsB;EACtB,MAAM;EACN,eAAe;EACf,MAAM;EACN,mBAAmB;EACnB,MAAM;EACN,qBAAqB;EACrB,MAAM;AACR;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;;;;CAOC;;AAED;EACE,gBAAgB;EAChB,MAAM;EACN,8BAA8B;EAC9B,MAAM;EACN,gBAAgB;EAChB,MAAM;EACN,cAAc;KACX,WAAW;EACd,MAAM;EACN,4NAA4N;EAC5N,MAAM;EACN,6BAA6B;EAC7B,MAAM;EACN,+BAA+B;EAC/B,MAAM;AACR;;AAEA;;;CAGC;;AAED;EACE,SAAS;EACT,MAAM;EACN,oBAAoB;EACpB,MAAM;AACR;;AAEA;;;;CAIC;;AAED;EACE,SAAS;EACT,MAAM;EACN,cAAc;EACd,MAAM;EACN,qBAAqB;EACrB,MAAM;AACR;;AAEA;;CAEC;;AAED;EACE,yCAAyC;UACjC,iCAAiC;AAC3C;;AAEA;;CAEC;;AAED;;;;;;EAME,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;CAEC;;AAED;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;;CAEC;;AAED;;EAEE,mBAAmB;AACrB;;AAEA;;;CAGC;;AAED;;;;EAIE,+GAA+G;EAC/G,MAAM;EACN,cAAc;EACd,MAAM;AACR;;AAEA;;CAEC;;AAED;EACE,cAAc;AAChB;;AAEA;;CAEC;;AAED;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;CAIC;;AAED;EACE,cAAc;EACd,MAAM;EACN,qBAAqB;EACrB,MAAM;EACN,yBAAyB;EACzB,MAAM;AACR;;AAEA;;;;CAIC;;AAED;;;;;EAKE,oBAAoB;EACpB,MAAM;EACN,8BAA8B;EAC9B,MAAM;EACN,gCAAgC;EAChC,MAAM;EACN,eAAe;EACf,MAAM;EACN,oBAAoB;EACpB,MAAM;EACN,oBAAoB;EACpB,MAAM;EACN,cAAc;EACd,MAAM;EACN,SAAS;EACT,MAAM;EACN,UAAU;EACV,MAAM;AACR;;AAEA;;CAEC;;AAED;;EAEE,oBAAoB;AACtB;;AAEA;;;CAGC;;AAED;;;;EAIE,0BAA0B;EAC1B,MAAM;EACN,6BAA6B;EAC7B,MAAM;EACN,sBAAsB;EACtB,MAAM;AACR;;AAEA;;CAEC;;AAED;EACE,aAAa;AACf;;AAEA;;CAEC;;AAED;EACE,gBAAgB;AAClB;;AAEA;;CAEC;;AAED;EACE,wBAAwB;AAC1B;;AAEA;;CAEC;;AAED;;EAEE,YAAY;AACd;;AAEA;;;CAGC;;AAED;EACE,6BAA6B;EAC7B,MAAM;EACN,oBAAoB;EACpB,MAAM;AACR;;AAEA;;CAEC;;AAED;EACE,wBAAwB;AAC1B;;AAEA;;;CAGC;;AAED;EACE,0BAA0B;EAC1B,MAAM;EACN,aAAa;EACb,MAAM;AACR;;AAEA;;CAEC;;AAED;EACE,kBAAkB;AACpB;;AAEA;;CAEC;;AAED;;;;;;;;;;;;;EAaE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;;CAEC;;AAED;EACE,UAAU;AACZ;;AAEA;;CAEC;;AAED;EACE,gBAAgB;AAClB;;AAEA;;;CAGC;;AAED;EACE,UAAU;EACV,MAAM;EACN,cAAc;EACd,MAAM;AACR;;AAEA;;EAEE,UAAU;EACV,MAAM;EACN,cAAc;EACd,MAAM;AACR;;AAEA;;CAEC;;AAED;;EAEE,eAAe;AACjB;;AAEA;;CAEC;;AAED;EACE,eAAe;AACjB;;AAEA;;;;CAIC;;AAED;;;;;;;;EAQE,cAAc;EACd,MAAM;EACN,sBAAsB;EACtB,MAAM;AACR;;AAEA;;CAEC;;AAED;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA,wEAAwE;;AAExE;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,+LAA+L;AACjM;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;KACtB,sBAAsB;UACjB,iBAAiB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;KACrB,qBAAqB;UAChB,gBAAgB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,sDAAsD;EACtD,+DAA+D;AACjE;;AAEA;EACE,uBAAuB;EACvB,4DAA4D;EAC5D,qDAAqD;AACvD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA;EACE,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;EACtB,yDAAyD;AAC3D;;AAEA;EACE,sBAAsB;EACtB,yDAAyD;EACzD,4DAA4D;AAC9D;;AAEA;EACE,sBAAsB;EACtB,6DAA6D;AAC/D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,oBAAoB;KACjB,iBAAiB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,uDAAuD;EACvD,uGAAuG;AACzG;;AAEA;EACE,gFAAgF;EAChF,oGAAoG;EACpG,uGAAuG;AACzG;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iLAAiL;AACnL;;AAEA;EACE,gKAAgK;EAChK,wJAAwJ;EACxJ,iLAAiL;EACjL,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,+FAA+F;EAC/F,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,sDAAsD;AACxD;;AAEA,gDAAgD;;AAEhD,4CAA4C;;AAE5C;EACE,iBAAiB;EACjB,iBAAiB;EACjB,+LAA+L;AACjM;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,+LAA+L;EACjM;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,+LAA+L;EACjM;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,+LAA+L;EACjM;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,+LAA+L;EACjM;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".notification-icon {\n  background-color: #ecaa1e;\n  font-size: medium;\n  font-weight: bold;\n  font-family: sans-serif;\n  border-radius: 50%;\n  color: #001e60;\n  position: absolute;\n  right: -10px;\n  top: -12px;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.red-notification-icon {\n  background-color: #ff3939;\n  font-size: medium;\n  font-weight: bold;\n  font-family: sans-serif;\n  border-radius: 50%;\n  color: #001e60;\n  position: absolute;\n  right: -4px;\n  top: -8px;\n  width: 20px;\n  height: 20px;\n}\n\n.relative-container {\n  position: relative;\n}\n\n.hidden {\n  display: none;\n  visibility: hidden;\n}\n\n.position-left {\n  left: -4px;\n}\n\n.blue-container {\n  background-color: #00468d;\n  color: white;\n  border-radius: 8px;\n  padding: 8px;\n  text-align: center;\n  transition: 300ms ease;\n}\n\n.blue-container:hover {\n  background-color: var(--dark-secondary-color);\n}\n\n.hoverable-blue-container {\n  background-color: #00468d;\n  color: white;\n  border-radius: 8px;\n  padding: 8px;\n  text-align: center;\n}\n\n.hoverable-blue-container:hover {\n  background-color: #001e60;\n}\n\n.dark-blue-container {\n  background-color: #001e60;\n  color: white;\n  border-radius: 8px;\n  padding: 8px;\n  text-align: center;\n}\n\n.blue-container > p {\n  font-size: 100%;\n}\n\n.dark-blue-container-with-border {\n  background: #001e60;\n  border-color: #ecaa1e;\n  border-radius: 8px;\n  border-style: solid;\n  border-width: 1px;\n  margin: 0px 10px;\n}\n\n.fadeIn\n{\n  animation: fadeIn 0.5s;\n}\n\n.fadeInFast\n{\n  animation: fadeIn 0.25s;\n}\n\n.toggleButton{\n  background-color: var(--primary-color);\n  width: 40px;\n  height: 20px;\n  border-radius: 200px;\n  cursor: pointer;\n  position: relative;\n  transition: 0.3s ease;\n  border-width: 1px;\n  border-color: white;\n}\n\n.toggleButton::before{\n  position: absolute;\n  content: '';\n  background-color: #fff;\n  width: 16px;\n  height: 16px;\n  margin: 1px;\n  border-radius: 200px;\n  transition: 0.3s ease;\n}\n\n.toggleInput:checked + .toggleButton{\n  background-color: var(--accent-color);\n}\n\n.toggleInput:checked + .toggleButton::before{\n  transform: translateX(20px);\n}\n\n.toggleInput{\n  display: none;\n}\n\n/*\n! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com\n*/\n\n/*\n1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)\n*/\n\n*,\n::before,\n::after {\n  box-sizing: border-box;\n  /* 1 */\n  border-width: 0;\n  /* 2 */\n  border-style: solid;\n  /* 2 */\n  border-color: #e5e7eb;\n  /* 2 */\n}\n\n::before,\n::after {\n  --tw-content: '';\n}\n\n/*\n1. Use a consistent sensible line-height in all browsers.\n2. Prevent adjustments of font size after orientation changes in iOS.\n3. Use a more readable tab size.\n4. Use the user's configured `sans` font-family by default.\n5. Use the user's configured `sans` font-feature-settings by default.\n6. Use the user's configured `sans` font-variation-settings by default.\n*/\n\nhtml {\n  line-height: 1.5;\n  /* 1 */\n  -webkit-text-size-adjust: 100%;\n  /* 2 */\n  -moz-tab-size: 4;\n  /* 3 */\n  -o-tab-size: 4;\n     tab-size: 4;\n  /* 3 */\n  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  /* 4 */\n  font-feature-settings: normal;\n  /* 5 */\n  font-variation-settings: normal;\n  /* 6 */\n}\n\n/*\n1. Remove the margin in all browsers.\n2. Inherit line-height from `html` so users can set them as a class directly on the `html` element.\n*/\n\nbody {\n  margin: 0;\n  /* 1 */\n  line-height: inherit;\n  /* 2 */\n}\n\n/*\n1. Add the correct height in Firefox.\n2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n3. Ensure horizontal rules are visible by default.\n*/\n\nhr {\n  height: 0;\n  /* 1 */\n  color: inherit;\n  /* 2 */\n  border-top-width: 1px;\n  /* 3 */\n}\n\n/*\nAdd the correct text decoration in Chrome, Edge, and Safari.\n*/\n\nabbr:where([title]) {\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted;\n}\n\n/*\nRemove the default font size and weight for headings.\n*/\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n\n/*\nReset links to optimize for opt-in styling instead of opt-out.\n*/\n\na {\n  color: inherit;\n  text-decoration: inherit;\n}\n\n/*\nAdd the correct font weight in Edge and Safari.\n*/\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/*\n1. Use the user's configured `mono` font family by default.\n2. Correct the odd `em` font sizing in all browsers.\n*/\n\ncode,\nkbd,\nsamp,\npre {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  /* 1 */\n  font-size: 1em;\n  /* 2 */\n}\n\n/*\nAdd the correct font size in all browsers.\n*/\n\nsmall {\n  font-size: 80%;\n}\n\n/*\nPrevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/*\n1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n3. Remove gaps between table borders by default.\n*/\n\ntable {\n  text-indent: 0;\n  /* 1 */\n  border-color: inherit;\n  /* 2 */\n  border-collapse: collapse;\n  /* 3 */\n}\n\n/*\n1. Change the font styles in all browsers.\n2. Remove the margin in Firefox and Safari.\n3. Remove default padding in all browsers.\n*/\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit;\n  /* 1 */\n  font-feature-settings: inherit;\n  /* 1 */\n  font-variation-settings: inherit;\n  /* 1 */\n  font-size: 100%;\n  /* 1 */\n  font-weight: inherit;\n  /* 1 */\n  line-height: inherit;\n  /* 1 */\n  color: inherit;\n  /* 1 */\n  margin: 0;\n  /* 2 */\n  padding: 0;\n  /* 3 */\n}\n\n/*\nRemove the inheritance of text transform in Edge and Firefox.\n*/\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Remove default button styles.\n*/\n\nbutton,\n[type='button'],\n[type='reset'],\n[type='submit'] {\n  -webkit-appearance: button;\n  /* 1 */\n  background-color: transparent;\n  /* 2 */\n  background-image: none;\n  /* 2 */\n}\n\n/*\nUse the modern Firefox focus style for all focusable elements.\n*/\n\n:-moz-focusring {\n  outline: auto;\n}\n\n/*\nRemove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n:-moz-ui-invalid {\n  box-shadow: none;\n}\n\n/*\nAdd the correct vertical alignment in Chrome and Firefox.\n*/\n\nprogress {\n  vertical-align: baseline;\n}\n\n/*\nCorrect the cursor style of increment and decrement buttons in Safari.\n*/\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/*\n1. Correct the odd appearance in Chrome and Safari.\n2. Correct the outline style in Safari.\n*/\n\n[type='search'] {\n  -webkit-appearance: textfield;\n  /* 1 */\n  outline-offset: -2px;\n  /* 2 */\n}\n\n/*\nRemove the inner padding in Chrome and Safari on macOS.\n*/\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Change font properties to `inherit` in Safari.\n*/\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button;\n  /* 1 */\n  font: inherit;\n  /* 2 */\n}\n\n/*\nAdd the correct display in Chrome and Safari.\n*/\n\nsummary {\n  display: list-item;\n}\n\n/*\nRemoves the default spacing and border for appropriate elements.\n*/\n\nblockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre {\n  margin: 0;\n}\n\nfieldset {\n  margin: 0;\n  padding: 0;\n}\n\nlegend {\n  padding: 0;\n}\n\nol,\nul,\nmenu {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/*\nReset default styling for dialogs.\n*/\n\ndialog {\n  padding: 0;\n}\n\n/*\nPrevent resizing textareas horizontally by default.\n*/\n\ntextarea {\n  resize: vertical;\n}\n\n/*\n1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n2. Set the default placeholder color to the user's configured gray 400 color.\n*/\n\ninput::-moz-placeholder, textarea::-moz-placeholder {\n  opacity: 1;\n  /* 1 */\n  color: #9ca3af;\n  /* 2 */\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  opacity: 1;\n  /* 1 */\n  color: #9ca3af;\n  /* 2 */\n}\n\n/*\nSet the default cursor for buttons.\n*/\n\nbutton,\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n/*\nMake sure disabled buttons don't get the pointer cursor.\n*/\n\n:disabled {\n  cursor: default;\n}\n\n/*\n1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n   This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n  display: block;\n  /* 1 */\n  vertical-align: middle;\n  /* 2 */\n}\n\n/*\nConstrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\nimg,\nvideo {\n  max-width: 100%;\n  height: auto;\n}\n\n/* Make elements with the HTML hidden attribute stay hidden by default */\n\n[hidden] {\n  display: none;\n}\n\n*, ::before, ::after {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n}\n\n::backdrop {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n}\n\n.pointer-events-none {\n  pointer-events: none;\n}\n\n.invisible {\n  visibility: hidden;\n}\n\n.fixed {\n  position: fixed;\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.inset-0 {\n  inset: 0px;\n}\n\n.-left-2 {\n  left: -0.5rem;\n}\n\n.bottom-10 {\n  bottom: 2.5rem;\n}\n\n.bottom-\\[-155px\\] {\n  bottom: -155px;\n}\n\n.bottom-\\[15\\%\\] {\n  bottom: 15%;\n}\n\n.bottom-\\[5\\%\\] {\n  bottom: 5%;\n}\n\n.bottom-\\[50\\%\\] {\n  bottom: 50%;\n}\n\n.bottom-\\[55\\%\\] {\n  bottom: 55%;\n}\n\n.left-0 {\n  left: 0px;\n}\n\n.left-1\\/2 {\n  left: 50%;\n}\n\n.left-5 {\n  left: 1.25rem;\n}\n\n.left-7 {\n  left: 1.75rem;\n}\n\n.left-\\[-100px\\] {\n  left: -100px;\n}\n\n.left-\\[24px\\] {\n  left: 24px;\n}\n\n.left-\\[380px\\] {\n  left: 380px;\n}\n\n.left-\\[40vw\\] {\n  left: 40vw;\n}\n\n.left-\\[5\\%\\] {\n  left: 5%;\n}\n\n.left-\\[50vw\\] {\n  left: 50vw;\n}\n\n.right-0 {\n  right: 0px;\n}\n\n.right-3 {\n  right: 0.75rem;\n}\n\n.right-\\[46\\%\\] {\n  right: 46%;\n}\n\n.right-\\[50\\%\\] {\n  right: 50%;\n}\n\n.top-0 {\n  top: 0px;\n}\n\n.top-10 {\n  top: 2.5rem;\n}\n\n.top-16 {\n  top: 4rem;\n}\n\n.top-2 {\n  top: 0.5rem;\n}\n\n.top-3 {\n  top: 0.75rem;\n}\n\n.top-4 {\n  top: 1rem;\n}\n\n.top-\\[15px\\] {\n  top: 15px;\n}\n\n.top-\\[15vh\\] {\n  top: 15vh;\n}\n\n.top-\\[80px\\] {\n  top: 80px;\n}\n\n.z-10 {\n  z-index: 10;\n}\n\n.z-30 {\n  z-index: 30;\n}\n\n.z-50 {\n  z-index: 50;\n}\n\n.z-\\[-1\\] {\n  z-index: -1;\n}\n\n.z-\\[100\\] {\n  z-index: 100;\n}\n\n.z-\\[101\\] {\n  z-index: 101;\n}\n\n.z-\\[99\\] {\n  z-index: 99;\n}\n\n.float-left {\n  float: left;\n}\n\n.m-8 {\n  margin: 2rem;\n}\n\n.mx-\\[10vw\\] {\n  margin-left: 10vw;\n  margin-right: 10vw;\n}\n\n.mx-\\[12\\%\\] {\n  margin-left: 12%;\n  margin-right: 12%;\n}\n\n.mx-\\[15px\\] {\n  margin-left: 15px;\n  margin-right: 15px;\n}\n\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.my-\\[14px\\] {\n  margin-top: 14px;\n  margin-bottom: 14px;\n}\n\n.my-\\[20px\\] {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem;\n}\n\n.mb-10 {\n  margin-bottom: 2.5rem;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem;\n}\n\n.mb-20 {\n  margin-bottom: 5rem;\n}\n\n.mb-4 {\n  margin-bottom: 1rem;\n}\n\n.mb-5 {\n  margin-bottom: 1.25rem;\n}\n\n.mb-\\[100px\\] {\n  margin-bottom: 100px;\n}\n\n.mb-\\[10px\\] {\n  margin-bottom: 10px;\n}\n\n.mb-\\[15px\\] {\n  margin-bottom: 15px;\n}\n\n.mb-\\[20px\\] {\n  margin-bottom: 20px;\n}\n\n.mb-\\[30px\\] {\n  margin-bottom: 30px;\n}\n\n.mb-\\[40px\\] {\n  margin-bottom: 40px;\n}\n\n.mb-\\[5px\\] {\n  margin-bottom: 5px;\n}\n\n.mb-\\[60px\\] {\n  margin-bottom: 60px;\n}\n\n.ml-8 {\n  margin-left: 2rem;\n}\n\n.ml-auto {\n  margin-left: auto;\n}\n\n.mr-0 {\n  margin-right: 0px;\n}\n\n.mr-3 {\n  margin-right: 0.75rem;\n}\n\n.mr-\\[10px\\] {\n  margin-right: 10px;\n}\n\n.mr-\\[12px\\] {\n  margin-right: 12px;\n}\n\n.mr-\\[30px\\] {\n  margin-right: 30px;\n}\n\n.mr-auto {\n  margin-right: auto;\n}\n\n.mt-10 {\n  margin-top: 2.5rem;\n}\n\n.mt-12 {\n  margin-top: 3rem;\n}\n\n.mt-16 {\n  margin-top: 4rem;\n}\n\n.mt-2 {\n  margin-top: 0.5rem;\n}\n\n.mt-28 {\n  margin-top: 7rem;\n}\n\n.mt-3 {\n  margin-top: 0.75rem;\n}\n\n.mt-4 {\n  margin-top: 1rem;\n}\n\n.mt-6 {\n  margin-top: 1.5rem;\n}\n\n.mt-\\[10px\\] {\n  margin-top: 10px;\n}\n\n.mt-\\[20px\\] {\n  margin-top: 20px;\n}\n\n.mt-\\[40px\\] {\n  margin-top: 40px;\n}\n\n.mt-\\[50px\\] {\n  margin-top: 50px;\n}\n\n.mt-\\[66px\\] {\n  margin-top: 66px;\n}\n\n.box-border {\n  box-sizing: border-box;\n}\n\n.flex {\n  display: flex;\n}\n\n.grid {\n  display: grid;\n}\n\n.hidden {\n  display: none;\n}\n\n.h-0 {\n  height: 0px;\n}\n\n.h-10 {\n  height: 2.5rem;\n}\n\n.h-14 {\n  height: 3.5rem;\n}\n\n.h-20 {\n  height: 5rem;\n}\n\n.h-24 {\n  height: 6rem;\n}\n\n.h-32 {\n  height: 8rem;\n}\n\n.h-36 {\n  height: 9rem;\n}\n\n.h-6 {\n  height: 1.5rem;\n}\n\n.h-8 {\n  height: 2rem;\n}\n\n.h-\\[100\\%\\] {\n  height: 100%;\n}\n\n.h-\\[100px\\] {\n  height: 100px;\n}\n\n.h-\\[100vh\\] {\n  height: 100vh;\n}\n\n.h-\\[126px\\] {\n  height: 126px;\n}\n\n.h-\\[155px\\] {\n  height: 155px;\n}\n\n.h-\\[30px\\] {\n  height: 30px;\n}\n\n.h-\\[40px\\] {\n  height: 40px;\n}\n\n.h-\\[50px\\] {\n  height: 50px;\n}\n\n.h-\\[50vh\\] {\n  height: 50vh;\n}\n\n.h-\\[60vh\\] {\n  height: 60vh;\n}\n\n.h-\\[80vh\\] {\n  height: 80vh;\n}\n\n.h-\\[82px\\] {\n  height: 82px;\n}\n\n.h-\\[85px\\] {\n  height: 85px;\n}\n\n.h-\\[89px\\] {\n  height: 89px;\n}\n\n.h-\\[90vh\\] {\n  height: 90vh;\n}\n\n.h-full {\n  height: 100%;\n}\n\n.max-h-0 {\n  max-height: 0px;\n}\n\n.max-h-\\[100\\%\\] {\n  max-height: 100%;\n}\n\n.max-h-\\[100vh\\] {\n  max-height: 100vh;\n}\n\n.max-h-\\[101px\\] {\n  max-height: 101px;\n}\n\n.max-h-\\[200px\\] {\n  max-height: 200px;\n}\n\n.max-h-\\[52px\\] {\n  max-height: 52px;\n}\n\n.min-h-\\[201px\\] {\n  min-height: 201px;\n}\n\n.min-h-full {\n  min-height: 100%;\n}\n\n.min-h-screen {\n  min-height: 100vh;\n}\n\n.w-0 {\n  width: 0px;\n}\n\n.w-10 {\n  width: 2.5rem;\n}\n\n.w-14 {\n  width: 3.5rem;\n}\n\n.w-24 {\n  width: 6rem;\n}\n\n.w-6 {\n  width: 1.5rem;\n}\n\n.w-64 {\n  width: 16rem;\n}\n\n.w-80 {\n  width: 20rem;\n}\n\n.w-\\[100\\%\\] {\n  width: 100%;\n}\n\n.w-\\[100px\\] {\n  width: 100px;\n}\n\n.w-\\[100vw\\] {\n  width: 100vw;\n}\n\n.w-\\[112\\.766px\\] {\n  width: 112.766px;\n}\n\n.w-\\[113px\\] {\n  width: 113px;\n}\n\n.w-\\[1600px\\] {\n  width: 1600px;\n}\n\n.w-\\[165px\\] {\n  width: 165px;\n}\n\n.w-\\[210px\\] {\n  width: 210px;\n}\n\n.w-\\[220px\\] {\n  width: 220px;\n}\n\n.w-\\[25\\%\\] {\n  width: 25%;\n}\n\n.w-\\[30\\%\\] {\n  width: 30%;\n}\n\n.w-\\[30px\\] {\n  width: 30px;\n}\n\n.w-\\[332px\\] {\n  width: 332px;\n}\n\n.w-\\[341px\\] {\n  width: 341px;\n}\n\n.w-\\[380px\\] {\n  width: 380px;\n}\n\n.w-\\[40px\\] {\n  width: 40px;\n}\n\n.w-\\[50\\%\\] {\n  width: 50%;\n}\n\n.w-\\[50px\\] {\n  width: 50px;\n}\n\n.w-\\[60\\%\\] {\n  width: 60%;\n}\n\n.w-\\[60px\\] {\n  width: 60px;\n}\n\n.w-\\[60vw\\] {\n  width: 60vw;\n}\n\n.w-\\[70\\%\\] {\n  width: 70%;\n}\n\n.w-\\[75\\%\\] {\n  width: 75%;\n}\n\n.w-\\[80\\%\\] {\n  width: 80%;\n}\n\n.w-\\[82px\\] {\n  width: 82px;\n}\n\n.w-\\[85px\\] {\n  width: 85px;\n}\n\n.w-\\[90\\%\\] {\n  width: 90%;\n}\n\n.w-\\[90px\\] {\n  width: 90px;\n}\n\n.w-\\[95\\%\\] {\n  width: 95%;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.min-w-\\[100vw\\] {\n  min-width: 100vw;\n}\n\n.min-w-\\[380px\\] {\n  min-width: 380px;\n}\n\n.max-w-\\[100\\%\\] {\n  max-width: 100%;\n}\n\n.max-w-\\[1200px\\] {\n  max-width: 1200px;\n}\n\n.max-w-\\[1600px\\] {\n  max-width: 1600px;\n}\n\n.max-w-\\[300px\\] {\n  max-width: 300px;\n}\n\n.max-w-\\[35\\%\\] {\n  max-width: 35%;\n}\n\n.max-w-\\[40\\%\\] {\n  max-width: 40%;\n}\n\n.max-w-\\[70\\%\\] {\n  max-width: 70%;\n}\n\n.flex-1 {\n  flex: 1 1 0%;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0;\n}\n\n.flex-grow {\n  flex-grow: 1;\n}\n\n.origin-top {\n  transform-origin: top;\n}\n\n.translate-x-\\[-50\\%\\] {\n  --tw-translate-x: -50%;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n@keyframes ali-fill {\n  0% {\n    transform: scaleY(0);\n  }\n\n  25% {\n    transform: scaleY(0);\n  }\n\n  50% {\n    transform: scaleY(1);\n  }\n\n  75% {\n    transform: scaleY(1);\n  }\n\n  100% {\n    transform: scaleY(0);\n  }\n}\n\n.animate-ali-fill {\n  animation: ali-fill 2s infinite ease-in;\n}\n\n@keyframes ali-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  25% {\n    transform: rotate(180deg);\n  }\n\n  50% {\n    transform: rotate(180deg);\n  }\n\n  75% {\n    transform: rotate(360deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.animate-ali-spin {\n  animation: ali-spin 2s infinite ease;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.select-none {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n}\n\n.resize-none {\n  resize: none;\n}\n\n.resize {\n  resize: both;\n}\n\n.appearance-none {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n}\n\n.auto-cols-auto {\n  grid-auto-columns: auto;\n}\n\n.grid-cols-4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.flex-row {\n  flex-direction: row;\n}\n\n.flex-col {\n  flex-direction: column;\n}\n\n.flex-col-reverse {\n  flex-direction: column-reverse;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.content-center {\n  align-content: center;\n}\n\n.items-start {\n  align-items: flex-start;\n}\n\n.items-end {\n  align-items: flex-end;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.justify-start {\n  justify-content: flex-start;\n}\n\n.justify-end {\n  justify-content: flex-end;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.justify-evenly {\n  justify-content: space-evenly;\n}\n\n.gap-2 {\n  gap: 0.5rem;\n}\n\n.gap-3 {\n  gap: 0.75rem;\n}\n\n.gap-4 {\n  gap: 1rem;\n}\n\n.gap-5 {\n  gap: 1.25rem;\n}\n\n.gap-6 {\n  gap: 1.5rem;\n}\n\n.space-x-2 > :not([hidden]) ~ :not([hidden]) {\n  --tw-space-x-reverse: 0;\n  margin-right: calc(0.5rem * var(--tw-space-x-reverse));\n  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));\n}\n\n.space-y-4 > :not([hidden]) ~ :not([hidden]) {\n  --tw-space-y-reverse: 0;\n  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));\n  margin-bottom: calc(1rem * var(--tw-space-y-reverse));\n}\n\n.overflow-auto {\n  overflow: auto;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.overflow-scroll {\n  overflow: scroll;\n}\n\n.overflow-y-auto {\n  overflow-y: auto;\n}\n\n.overflow-x-hidden {\n  overflow-x: hidden;\n}\n\n.overflow-y-hidden {\n  overflow-y: hidden;\n}\n\n.overflow-y-scroll {\n  overflow-y: scroll;\n}\n\n.overflow-ellipsis {\n  text-overflow: ellipsis;\n}\n\n.whitespace-normal {\n  white-space: normal;\n}\n\n.whitespace-nowrap {\n  white-space: nowrap;\n}\n\n.break-words {\n  overflow-wrap: break-word;\n}\n\n.rounded {\n  border-radius: 0.25rem;\n}\n\n.rounded-2xl {\n  border-radius: 1rem;\n}\n\n.rounded-3xl {\n  border-radius: 1.5rem;\n}\n\n.rounded-\\[10px\\] {\n  border-radius: 10px;\n}\n\n.rounded-\\[15px\\] {\n  border-radius: 15px;\n}\n\n.rounded-\\[20px\\] {\n  border-radius: 20px;\n}\n\n.rounded-\\[50\\%\\] {\n  border-radius: 50%;\n}\n\n.rounded-full {\n  border-radius: 9999px;\n}\n\n.rounded-lg {\n  border-radius: 0.5rem;\n}\n\n.rounded-md {\n  border-radius: 0.375rem;\n}\n\n.rounded-xl {\n  border-radius: 0.75rem;\n}\n\n.rounded-b-\\[15px\\] {\n  border-bottom-right-radius: 15px;\n  border-bottom-left-radius: 15px;\n}\n\n.rounded-t-\\[15px\\] {\n  border-top-left-radius: 15px;\n  border-top-right-radius: 15px;\n}\n\n.border {\n  border-width: 1px;\n}\n\n.border-2 {\n  border-width: 2px;\n}\n\n.border-\\[1\\.5px\\] {\n  border-width: 1.5px;\n}\n\n.border-\\[4px\\] {\n  border-width: 4px;\n}\n\n.border-y-0 {\n  border-top-width: 0px;\n  border-bottom-width: 0px;\n}\n\n.border-b-2 {\n  border-bottom-width: 2px;\n}\n\n.border-r-2 {\n  border-right-width: 2px;\n}\n\n.border-t-2 {\n  border-top-width: 2px;\n}\n\n.border-none {\n  border-style: none;\n}\n\n.border-ali-backgroundblue {\n  --tw-border-opacity: 1;\n  border-color: rgb(0 150 201 / var(--tw-border-opacity));\n}\n\n.border-ali-darkblue {\n  --tw-border-opacity: 1;\n  border-color: rgb(0 30 96 / var(--tw-border-opacity));\n}\n\n.border-black {\n  --tw-border-opacity: 1;\n  border-color: rgb(0 0 0 / var(--tw-border-opacity));\n}\n\n.border-white {\n  --tw-border-opacity: 1;\n  border-color: rgb(255 255 255 / var(--tw-border-opacity));\n}\n\n.border-y-ali-darkblue {\n  --tw-border-opacity: 1;\n  border-top-color: rgb(0 30 96 / var(--tw-border-opacity));\n  border-bottom-color: rgb(0 30 96 / var(--tw-border-opacity));\n}\n\n.border-r-ali-backgroundblue {\n  --tw-border-opacity: 1;\n  border-right-color: rgb(0 150 201 / var(--tw-border-opacity));\n}\n\n.border-opacity-50 {\n  --tw-border-opacity: 0.5;\n}\n\n.bg-\\[\\#001A52\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(0 26 82 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#001E60\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(0 30 96 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#00468D\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(0 70 141 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#2C6BAC\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(44 107 172 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#C5C5C5\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(197 197 197 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#D9D9D9\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(217 217 217 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#ECAA1E\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(236 170 30 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#EDEDED\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(237 237 237 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#F5F5F5\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(245 245 245 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#FFFFFF\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\n}\n\n.bg-\\[color\\:var\\(--secondary-color\\)\\] {\n  background-color: var(--secondary-color);\n}\n\n.bg-ali-backgroundblue {\n  --tw-bg-opacity: 1;\n  background-color: rgb(0 150 201 / var(--tw-bg-opacity));\n}\n\n.bg-ali-darkblue {\n  --tw-bg-opacity: 1;\n  background-color: rgb(0 30 96 / var(--tw-bg-opacity));\n}\n\n.bg-ali-lightblue {\n  --tw-bg-opacity: 1;\n  background-color: rgb(0 70 141 / var(--tw-bg-opacity));\n}\n\n.bg-ali-orange {\n  --tw-bg-opacity: 1;\n  background-color: rgb(236 170 30 / var(--tw-bg-opacity));\n}\n\n.bg-black {\n  --tw-bg-opacity: 1;\n  background-color: rgb(0 0 0 / var(--tw-bg-opacity));\n}\n\n.bg-red-500 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(239 68 68 / var(--tw-bg-opacity));\n}\n\n.bg-slate-400 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(148 163 184 / var(--tw-bg-opacity));\n}\n\n.bg-transparent {\n  background-color: transparent;\n}\n\n.bg-white {\n  --tw-bg-opacity: 1;\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\n}\n\n.bg-yellow-500 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(234 179 8 / var(--tw-bg-opacity));\n}\n\n.object-cover {\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n\n.p-1 {\n  padding: 0.25rem;\n}\n\n.p-2 {\n  padding: 0.5rem;\n}\n\n.p-4 {\n  padding: 1rem;\n}\n\n.p-6 {\n  padding: 1.5rem;\n}\n\n.p-8 {\n  padding: 2rem;\n}\n\n.p-\\[15px\\] {\n  padding: 15px;\n}\n\n.p-\\[25px\\] {\n  padding: 25px;\n}\n\n.px-2 {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n\n.px-3 {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n\n.px-4 {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.px-6 {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n\n.px-7 {\n  padding-left: 1.75rem;\n  padding-right: 1.75rem;\n}\n\n.px-8 {\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n\n.px-\\[10px\\] {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.px-\\[15px\\] {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.px-\\[24px\\] {\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n.px-\\[25px\\] {\n  padding-left: 25px;\n  padding-right: 25px;\n}\n\n.px-\\[30px\\] {\n  padding-left: 30px;\n  padding-right: 30px;\n}\n\n.px-\\[5\\%\\] {\n  padding-left: 5%;\n  padding-right: 5%;\n}\n\n.px-\\[50px\\] {\n  padding-left: 50px;\n  padding-right: 50px;\n}\n\n.px-\\[5px\\] {\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.py-1 {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n}\n\n.py-2 {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.py-3 {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n\n.py-4 {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.py-5 {\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n}\n\n.py-8 {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n\n.py-\\[10px\\] {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.py-\\[20px\\] {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n.py-\\[40px\\] {\n  padding-top: 40px;\n  padding-bottom: 40px;\n}\n\n.py-\\[5px\\] {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem;\n}\n\n.pb-3 {\n  padding-bottom: 0.75rem;\n}\n\n.pb-4 {\n  padding-bottom: 1rem;\n}\n\n.pb-8 {\n  padding-bottom: 2rem;\n}\n\n.pb-\\[100px\\] {\n  padding-bottom: 100px;\n}\n\n.pb-\\[40px\\] {\n  padding-bottom: 40px;\n}\n\n.pl-20 {\n  padding-left: 5rem;\n}\n\n.pl-\\[125px\\] {\n  padding-left: 125px;\n}\n\n.pr-2 {\n  padding-right: 0.5rem;\n}\n\n.pt-2 {\n  padding-top: 0.5rem;\n}\n\n.pt-2\\.5 {\n  padding-top: 0.625rem;\n}\n\n.pt-4 {\n  padding-top: 1rem;\n}\n\n.pt-5 {\n  padding-top: 1.25rem;\n}\n\n.pt-\\[10px\\] {\n  padding-top: 10px;\n}\n\n.pt-\\[20px\\] {\n  padding-top: 20px;\n}\n\n.pt-\\[66px\\] {\n  padding-top: 66px;\n}\n\n.pl-24 {\n  padding-left: 6rem;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-2xl {\n  font-size: 1.5rem;\n  line-height: 2rem;\n}\n\n.text-3xl {\n  font-size: 1.875rem;\n  line-height: 2.25rem;\n}\n\n.text-5xl {\n  font-size: 3rem;\n  line-height: 1;\n}\n\n.text-\\[110\\%\\] {\n  font-size: 110%;\n}\n\n.text-\\[12px\\] {\n  font-size: 12px;\n}\n\n.text-\\[130\\%\\] {\n  font-size: 130%;\n}\n\n.text-\\[13px\\] {\n  font-size: 13px;\n}\n\n.text-\\[140\\%\\] {\n  font-size: 140%;\n}\n\n.text-\\[14px\\] {\n  font-size: 14px;\n}\n\n.text-\\[18px\\] {\n  font-size: 18px;\n}\n\n.text-\\[20px\\] {\n  font-size: 20px;\n}\n\n.text-\\[28px\\] {\n  font-size: 28px;\n}\n\n.text-\\[80\\%\\] {\n  font-size: 80%;\n}\n\n.text-base {\n  font-size: 1rem;\n  line-height: 1.5rem;\n}\n\n.text-lg {\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n}\n\n.text-sm {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n.text-xs {\n  font-size: 0.75rem;\n  line-height: 1rem;\n}\n\n.font-\\[400\\] {\n  font-weight: 400;\n}\n\n.font-\\[500\\] {\n  font-weight: 500;\n}\n\n.font-\\[600\\] {\n  font-weight: 600;\n}\n\n.font-bold {\n  font-weight: 700;\n}\n\n.font-medium {\n  font-weight: 500;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n.text-\\[\\#002347\\] {\n  --tw-text-opacity: 1;\n  color: rgb(0 35 71 / var(--tw-text-opacity));\n}\n\n.text-\\[\\#23F638\\] {\n  --tw-text-opacity: 1;\n  color: rgb(35 246 56 / var(--tw-text-opacity));\n}\n\n.text-\\[\\#465985\\] {\n  --tw-text-opacity: 1;\n  color: rgb(70 89 133 / var(--tw-text-opacity));\n}\n\n.text-\\[\\#FE2F2F\\] {\n  --tw-text-opacity: 1;\n  color: rgb(254 47 47 / var(--tw-text-opacity));\n}\n\n.text-\\[\\#ecaa1e\\] {\n  --tw-text-opacity: 1;\n  color: rgb(236 170 30 / var(--tw-text-opacity));\n}\n\n.text-\\[var\\(--accent-color\\)\\] {\n  color: var(--accent-color);\n}\n\n.text-ali-darkblue {\n  --tw-text-opacity: 1;\n  color: rgb(0 30 96 / var(--tw-text-opacity));\n}\n\n.text-ali-orange {\n  --tw-text-opacity: 1;\n  color: rgb(236 170 30 / var(--tw-text-opacity));\n}\n\n.text-black {\n  --tw-text-opacity: 1;\n  color: rgb(0 0 0 / var(--tw-text-opacity));\n}\n\n.text-regal-blue {\n  --tw-text-opacity: 1;\n  color: rgb(36 60 90 / var(--tw-text-opacity));\n}\n\n.text-white {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity));\n}\n\n.underline {\n  text-decoration-line: underline;\n}\n\n.opacity-0 {\n  opacity: 0;\n}\n\n.opacity-100 {\n  opacity: 1;\n}\n\n.opacity-50 {\n  opacity: 0.5;\n}\n\n.opacity-60 {\n  opacity: 0.6;\n}\n\n.shadow-sm {\n  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.shadow-xl {\n  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.outline-none {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n}\n\n.filter {\n  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n}\n\n.transition {\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.transition-all {\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.transition-colors {\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.transition-opacity {\n  transition-property: opacity;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.duration-300 {\n  transition-duration: 300ms;\n}\n\n.duration-500 {\n  transition-duration: 500ms;\n}\n\n.duration-\\[300ms\\] {\n  transition-duration: 300ms;\n}\n\n.ease-in-out {\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.ease-out {\n  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n\n/* Hide scrollbar for IE, Edge and Firefox */\n\n.hover\\:scale-\\[1\\.1\\]:hover {\n  --tw-scale-x: 1.1;\n  --tw-scale-y: 1.1;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.hover\\:bg-\\[\\#00468D\\]:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(0 70 141 / var(--tw-bg-opacity));\n}\n\n.hover\\:bg-\\[color\\:var\\(--dark-secondary-color\\)\\]:hover {\n  background-color: var(--dark-secondary-color);\n}\n\n.hover\\:bg-\\[color\\:var\\(--secondary-color\\)\\]:hover {\n  background-color: var(--secondary-color);\n}\n\n.hover\\:bg-ali-darkblue:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(0 30 96 / var(--tw-bg-opacity));\n}\n\n.hover\\:bg-ali-lightblue:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(0 70 141 / var(--tw-bg-opacity));\n}\n\n.hover\\:text-\\[color\\:var\\(--accent-color\\)\\]:hover {\n  color: var(--accent-color);\n}\n\n.hover\\:text-\\[white\\]:hover {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity));\n}\n\n.hover\\:text-white:hover {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity));\n}\n\n@media (max-width: 1250px) {\n  .xxlr\\:mr-\\[0px\\] {\n    margin-right: 0px;\n  }\n\n  .xxlr\\:w-\\[86\\%\\] {\n    width: 86%;\n  }\n\n  .xxlr\\:max-w-\\[400px\\] {\n    max-width: 400px;\n  }\n\n  .xxlr\\:grid-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .xxlr\\:text-start {\n    text-align: start;\n  }\n\n  .xxlr\\:text-\\[120\\%\\] {\n    font-size: 120%;\n  }\n}\n\n@media (max-width: 1050px) {\n  .xlr\\:h-\\[40px\\] {\n    height: 40px;\n  }\n\n  .xlr\\:w-\\[180px\\] {\n    width: 180px;\n  }\n\n  .xlr\\:w-\\[40px\\] {\n    width: 40px;\n  }\n\n  .xlr\\:max-w-\\[300px\\] {\n    max-width: 300px;\n  }\n\n  .xlr\\:max-w-\\[40\\%\\] {\n    max-width: 40%;\n  }\n\n  .xlr\\:items-center {\n    align-items: center;\n  }\n\n  .xlr\\:px-\\[20px\\] {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .xlr\\:text-\\[100\\%\\] {\n    font-size: 100%;\n  }\n\n  .xlr\\:text-\\[110\\%\\] {\n    font-size: 110%;\n  }\n\n  .xlr\\:text-\\[14px\\] {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 850px) {\n  .lr\\:mt-24 {\n    margin-top: 6rem;\n  }\n\n  .lr\\:mt-32 {\n    margin-top: 8rem;\n  }\n\n  .lr\\:mt-\\[100px\\] {\n    margin-top: 100px;\n  }\n\n  .lr\\:mt-\\[120px\\] {\n    margin-top: 120px;\n  }\n\n  .lr\\:mt-\\[160px\\] {\n    margin-top: 160px;\n  }\n\n  .lr\\:mt-\\[70px\\] {\n    margin-top: 70px;\n  }\n\n  .lr\\:h-\\[100vh\\] {\n    height: 100vh;\n  }\n\n  .lr\\:h-\\[30px\\] {\n    height: 30px;\n  }\n\n  .lr\\:h-\\[35px\\] {\n    height: 35px;\n  }\n\n  .lr\\:h-auto {\n    height: auto;\n  }\n\n  .lr\\:w-\\[100vw\\] {\n    width: 100vw;\n  }\n\n  .lr\\:w-\\[160px\\] {\n    width: 160px;\n  }\n\n  .lr\\:w-\\[30px\\] {\n    width: 30px;\n  }\n\n  .lr\\:w-\\[35px\\] {\n    width: 35px;\n  }\n\n  .lr\\:w-\\[70px\\] {\n    width: 70px;\n  }\n\n  .lr\\:w-\\[70vw\\] {\n    width: 70vw;\n  }\n\n  .lr\\:w-\\[80\\%\\] {\n    width: 80%;\n  }\n\n  .lr\\:w-\\[85\\%\\] {\n    width: 85%;\n  }\n\n  .lr\\:w-\\[92\\%\\] {\n    width: 92%;\n  }\n\n  .lr\\:max-w-\\[1000px\\] {\n    max-width: 1000px;\n  }\n\n  .lr\\:scale-\\[1\\.0\\] {\n    --tw-scale-x: 1.0;\n    --tw-scale-y: 1.0;\n    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n  }\n\n  .lr\\:animate-none {\n    animation: none;\n  }\n\n  .lr\\:grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .lr\\:flex-col {\n    flex-direction: column;\n  }\n\n  .lr\\:items-center {\n    align-items: center;\n  }\n\n  .lr\\:justify-end {\n    justify-content: flex-end;\n  }\n\n  .lr\\:overflow-y-scroll {\n    overflow-y: scroll;\n  }\n\n  .lr\\:border-r-0 {\n    border-right-width: 0px;\n  }\n\n  .lr\\:p-\\[10px\\] {\n    padding: 10px;\n  }\n\n  .lr\\:py-0 {\n    padding-top: 0px;\n    padding-bottom: 0px;\n  }\n\n  .lr\\:pb-\\[50px\\] {\n    padding-bottom: 50px;\n  }\n\n  .lr\\:pt-\\[110px\\] {\n    padding-top: 110px;\n  }\n\n  .lr\\:pt-\\[3rem\\] {\n    padding-top: 3rem;\n  }\n\n  .lr\\:pt-\\[66px\\] {\n    padding-top: 66px;\n  }\n\n  .lr\\:text-\\[100\\%\\] {\n    font-size: 100%;\n  }\n\n  .lr\\:text-\\[12px\\] {\n    font-size: 12px;\n  }\n\n  .lr\\:text-\\[16px\\] {\n    font-size: 16px;\n  }\n\n  .lr\\:text-\\[22px\\] {\n    font-size: 22px;\n  }\n\n  .lr\\:text-\\[90\\%\\] {\n    font-size: 90%;\n  }\n}\n\n@media (max-width: 600px) {\n  .md\\:absolute {\n    position: absolute;\n  }\n\n  .md\\:top-0 {\n    top: 0px;\n  }\n\n  .md\\:top-\\[15vh\\] {\n    top: 15vh;\n  }\n\n  .md\\:ml-0 {\n    margin-left: 0px;\n  }\n\n  .md\\:mt-32 {\n    margin-top: 8rem;\n  }\n\n  .md\\:mt-\\[100px\\] {\n    margin-top: 100px;\n  }\n\n  .md\\:mt-\\[10px\\] {\n    margin-top: 10px;\n  }\n\n  .md\\:line-clamp-2 {\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n  }\n\n  .md\\:hidden {\n    display: none;\n  }\n\n  .md\\:h-\\[30px\\] {\n    height: 30px;\n  }\n\n  .md\\:h-\\[65vh\\] {\n    height: 65vh;\n  }\n\n  .md\\:w-\\[100\\%\\] {\n    width: 100%;\n  }\n\n  .md\\:w-\\[30px\\] {\n    width: 30px;\n  }\n\n  .md\\:w-\\[80vw\\] {\n    width: 80vw;\n  }\n\n  .md\\:w-\\[95\\%\\] {\n    width: 95%;\n  }\n\n  .md\\:scale-\\[0\\.9\\] {\n    --tw-scale-x: 0.9;\n    --tw-scale-y: 0.9;\n    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n  }\n\n  .md\\:grid-cols-1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n\n  .md\\:flex-col {\n    flex-direction: column;\n  }\n\n  .md\\:flex-nowrap {\n    flex-wrap: nowrap;\n  }\n\n  .md\\:items-start {\n    align-items: flex-start;\n  }\n\n  .md\\:justify-end {\n    justify-content: flex-end;\n  }\n\n  .md\\:justify-center {\n    justify-content: center;\n  }\n\n  .md\\:px-\\[10px\\] {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n\n  .md\\:py-\\[10px\\] {\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n\n  .md\\:pt-0 {\n    padding-top: 0px;\n  }\n\n  .md\\:text-center {\n    text-align: center;\n  }\n\n  .md\\:text-\\[12px\\] {\n    font-size: 12px;\n  }\n\n  .md\\:text-\\[13px\\] {\n    font-size: 13px;\n  }\n\n  .md\\:text-\\[14px\\] {\n    font-size: 14px;\n  }\n\n  .md\\:text-\\[16px\\] {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .sm\\:mx-\\[20px\\] {\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n\n  .sm\\:mb-1 {\n    margin-bottom: 0.25rem;\n  }\n\n  .sm\\:mb-\\[30px\\] {\n    margin-bottom: 30px;\n  }\n\n  .sm\\:mt-\\[140px\\] {\n    margin-top: 140px;\n  }\n\n  .sm\\:hidden {\n    display: none;\n  }\n\n  .sm\\:h-\\[100px\\] {\n    height: 100px;\n  }\n\n  .sm\\:h-\\[20px\\] {\n    height: 20px;\n  }\n\n  .sm\\:h-\\[60px\\] {\n    height: 60px;\n  }\n\n  .sm\\:w-\\[130px\\] {\n    width: 130px;\n  }\n\n  .sm\\:w-\\[20px\\] {\n    width: 20px;\n  }\n\n  .sm\\:w-\\[50px\\] {\n    width: 50px;\n  }\n\n  .sm\\:w-\\[90\\%\\] {\n    width: 90%;\n  }\n\n  .sm\\:w-\\[90vw\\] {\n    width: 90vw;\n  }\n\n  .sm\\:scale-\\[0\\.8\\] {\n    --tw-scale-x: 0.8;\n    --tw-scale-y: 0.8;\n    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n  }\n\n  .sm\\:justify-around {\n    justify-content: space-around;\n  }\n\n  .sm\\:p-6 {\n    padding: 1.5rem;\n  }\n\n  .sm\\:p-\\[5px\\] {\n    padding: 5px;\n  }\n\n  .sm\\:px-\\[10px\\] {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n\n  .sm\\:pt-\\[0px\\] {\n    padding-top: 0px;\n  }\n\n  .sm\\:text-\\[12px\\] {\n    font-size: 12px;\n  }\n\n  .sm\\:text-\\[14px\\] {\n    font-size: 14px;\n  }\n\n  .sm\\:text-\\[16px\\] {\n    font-size: 16px;\n  }\n\n  .sm\\:text-\\[18px\\] {\n    font-size: 18px;\n  }\n\n  .sm\\:text-\\[70\\%\\] {\n    font-size: 70%;\n  }\n\n  .sm\\:text-\\[80\\%\\] {\n    font-size: 80%;\n  }\n\n  .sm\\:text-\\[85\\%\\] {\n    font-size: 85%;\n  }\n}\n\n@media (max-width: 350px) {\n  .xsm\\:w-\\[100px\\] {\n    width: 100px;\n  }\n\n  .xsm\\:w-\\[200px\\] {\n    width: 200px;\n  }\n\n  .xsm\\:w-\\[95\\%\\] {\n    width: 95%;\n  }\n\n  .xsm\\:scale-\\[0\\.7\\] {\n    --tw-scale-x: 0.7;\n    --tw-scale-y: 0.7;\n    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n  }\n\n  .xsm\\:pt-\\[10px\\] {\n    padding-top: 10px;\n  }\n\n  .xsm\\:text-\\[11px\\] {\n    font-size: 11px;\n  }\n\n  .xsm\\:text-\\[60\\%\\] {\n    font-size: 60%;\n  }\n\n  .xsm\\:text-\\[70\\%\\] {\n    font-size: 70%;\n  }\n\n  .xsm\\:text-\\[80\\%\\] {\n    font-size: 80%;\n  }\n}\n\n@media (min-width: 480px) {\n  .mdd\\:hidden {\n    display: none;\n  }\n}\n\n@media (min-width: 600px) {\n  .lrr\\:mt-0 {\n    margin-top: 0px;\n  }\n\n  .lrr\\:hidden {\n    display: none;\n  }\n}\n\n@media (min-width: 850px) {\n  .xlrr\\:fixed {\n    position: fixed;\n  }\n\n  .xlrr\\:hidden {\n    display: none;\n  }\n}\n\n@media (min-width: 414px) {\n  .txsm\\:top-10 {\n    top: 2.5rem;\n  }\n\n  .txsm\\:top-6 {\n    top: 1.5rem;\n  }\n\n  .txsm\\:h-\\[0px\\] {\n    height: 0px;\n  }\n\n  .txsm\\:h-\\[150px\\] {\n    height: 150px;\n  }\n\n  .txsm\\:h-\\[300px\\] {\n    height: 300px;\n  }\n}\n\n@media (min-width: 600px) {\n  .tsm\\:h-36 {\n    height: 9rem;\n  }\n\n  .tsm\\:h-\\[180px\\] {\n    height: 180px;\n  }\n\n  .tsm\\:h-\\[230px\\] {\n    height: 230px;\n  }\n\n  .tsm\\:h-\\[275px\\] {\n    height: 275px;\n  }\n\n  .tsm\\:h-\\[300px\\] {\n    height: 300px;\n  }\n\n  .tsm\\:h-\\[350px\\] {\n    height: 350px;\n  }\n\n  .tsm\\:w-72 {\n    width: 18rem;\n  }\n\n  .tsm\\:w-\\[90\\%\\] {\n    width: 90%;\n  }\n\n  .tsm\\:flex-row {\n    flex-direction: row;\n  }\n\n  .tsm\\:items-center {\n    align-items: center;\n  }\n\n  .tsm\\:justify-center {\n    justify-content: center;\n  }\n\n  .tsm\\:gap-10 {\n    gap: 2.5rem;\n  }\n}\n\n@media (min-width: 780px) {\n  .tmd\\:absolute {\n    position: absolute;\n  }\n\n  .tmd\\:left-20 {\n    left: 5rem;\n  }\n\n  .tmd\\:left-4 {\n    left: 1rem;\n  }\n\n  .tmd\\:top-8 {\n    top: 2rem;\n  }\n\n  .tmd\\:top-\\[24px\\] {\n    top: 24px;\n  }\n\n  .tmd\\:mt-0 {\n    margin-top: 0px;\n  }\n\n  .tmd\\:h-44 {\n    height: 11rem;\n  }\n\n  .tmd\\:h-\\[175px\\] {\n    height: 175px;\n  }\n\n  .tmd\\:h-\\[200px\\] {\n    height: 200px;\n  }\n\n  .tmd\\:h-\\[250px\\] {\n    height: 250px;\n  }\n\n  .tmd\\:h-\\[260px\\] {\n    height: 260px;\n  }\n\n  .tmd\\:h-\\[335px\\] {\n    height: 335px;\n  }\n\n  .tmd\\:h-28 {\n    height: 7rem;\n  }\n\n  .tmd\\:w-80 {\n    width: 20rem;\n  }\n\n  .tmd\\:w-28 {\n    width: 7rem;\n  }\n\n  .tmd\\:gap-20 {\n    gap: 5rem;\n  }\n}\n\n@media (min-width: 1024px) {\n  .tlg\\:absolute {\n    position: absolute;\n  }\n\n  .tlg\\:left-36 {\n    left: 9rem;\n  }\n\n  .tlg\\:top-8 {\n    top: 2rem;\n  }\n\n  .tlg\\:top-\\[35px\\] {\n    top: 35px;\n  }\n\n  .tlg\\:left-32 {\n    left: 8rem;\n  }\n\n  .tlg\\:top-\\[24px\\] {\n    top: 24px;\n  }\n\n  .tlg\\:mt-0 {\n    margin-top: 0px;\n  }\n\n  .tlg\\:mt-20 {\n    margin-top: 5rem;\n  }\n\n  .tlg\\:mt-24 {\n    margin-top: 6rem;\n  }\n\n  .tlg\\:flex {\n    display: flex;\n  }\n\n  .tlg\\:h-14 {\n    height: 3.5rem;\n  }\n\n  .tlg\\:h-44 {\n    height: 11rem;\n  }\n\n  .tlg\\:h-\\[130px\\] {\n    height: 130px;\n  }\n\n  .tlg\\:h-\\[170px\\] {\n    height: 170px;\n  }\n\n  .tlg\\:h-\\[176px\\] {\n    height: 176px;\n  }\n\n  .tlg\\:h-16 {\n    height: 4rem;\n  }\n\n  .tlg\\:h-32 {\n    height: 8rem;\n  }\n\n  .tlg\\:h-52 {\n    height: 13rem;\n  }\n\n  .tlg\\:w-14 {\n    width: 3.5rem;\n  }\n\n  .tlg\\:w-80 {\n    width: 20rem;\n  }\n\n  .tlg\\:w-\\[70\\%\\] {\n    width: 70%;\n  }\n\n  .tlg\\:w-\\[80\\%\\] {\n    width: 80%;\n  }\n\n  .tlg\\:w-16 {\n    width: 4rem;\n  }\n\n  .tlg\\:w-32 {\n    width: 8rem;\n  }\n\n  .tlg\\:w-\\[430px\\] {\n    width: 430px;\n  }\n\n  .tlg\\:w-\\[439px\\] {\n    width: 439px;\n  }\n\n  .tlg\\:w-\\[90\\%\\] {\n    width: 90%;\n  }\n\n  .tlg\\:flex-row {\n    flex-direction: row;\n  }\n\n  .tlg\\:items-center {\n    align-items: center;\n  }\n\n  .tlg\\:justify-center {\n    justify-content: center;\n  }\n\n  .tlg\\:gap-20 {\n    gap: 5rem;\n  }\n\n  .tlg\\:text-base {\n    font-size: 1rem;\n    line-height: 1.5rem;\n  }\n}\n\n@media (min-width: 1280px) {\n  .txl\\:absolute {\n    position: absolute;\n  }\n\n  .txl\\:left-40 {\n    left: 10rem;\n  }\n\n  .txl\\:top-8 {\n    top: 2rem;\n  }\n\n  .txl\\:top-\\[35px\\] {\n    top: 35px;\n  }\n\n  .txl\\:left-36 {\n    left: 9rem;\n  }\n\n  .txl\\:top-\\[24px\\] {\n    top: 24px;\n  }\n\n  .txl\\:mt-20 {\n    margin-top: 5rem;\n  }\n\n  .txl\\:mt-24 {\n    margin-top: 6rem;\n  }\n\n  .txl\\:h-44 {\n    height: 11rem;\n  }\n\n  .txl\\:h-\\[120px\\] {\n    height: 120px;\n  }\n\n  .txl\\:h-\\[150px\\] {\n    height: 150px;\n  }\n\n  .txl\\:h-\\[230px\\] {\n    height: 230px;\n  }\n\n  .txl\\:h-\\[250px\\] {\n    height: 250px;\n  }\n\n  .txl\\:h-\\[260px\\] {\n    height: 260px;\n  }\n\n  .txl\\:h-52 {\n    height: 13rem;\n  }\n\n  .txl\\:w-96 {\n    width: 24rem;\n  }\n\n  .txl\\:w-\\[70\\%\\] {\n    width: 70%;\n  }\n\n  .txl\\:w-\\[450px\\] {\n    width: 450px;\n  }\n\n  .txl\\:gap-48 {\n    gap: 12rem;\n  }\n\n  .txl\\:gap-20 {\n    gap: 5rem;\n  }\n}\n\n@media (min-width: 1536px) {\n  .t2xl\\:absolute {\n    position: absolute;\n  }\n\n  .t2xl\\:left-52 {\n    left: 13rem;\n  }\n\n  .t2xl\\:top-8 {\n    top: 2rem;\n  }\n\n  .t2xl\\:left-48 {\n    left: 12rem;\n  }\n\n  .t2xl\\:top-\\[24px\\] {\n    top: 24px;\n  }\n\n  .t2xl\\:mt-20 {\n    margin-top: 5rem;\n  }\n\n  .t2xl\\:mt-32 {\n    margin-top: 8rem;\n  }\n\n  .t2xl\\:h-\\[130px\\] {\n    height: 130px;\n  }\n\n  .t2xl\\:h-\\[150px\\] {\n    height: 150px;\n  }\n\n  .t2xl\\:h-\\[180px\\] {\n    height: 180px;\n  }\n\n  .t2xl\\:h-\\[190px\\] {\n    height: 190px;\n  }\n\n  .t2xl\\:h-\\[200px\\] {\n    height: 200px;\n  }\n\n  .t2xl\\:h-\\[350px\\] {\n    height: 350px;\n  }\n\n  .t2xl\\:h-60 {\n    height: 15rem;\n  }\n\n  .t2xl\\:h-\\[400px\\] {\n    height: 400px;\n  }\n\n  .t2xl\\:h-\\[550px\\] {\n    height: 550px;\n  }\n\n  .t2xl\\:w-\\[70\\%\\] {\n    width: 70%;\n  }\n\n  .t2xl\\:w-\\[80\\%\\] {\n    width: 80%;\n  }\n\n  .t2xl\\:w-\\[550px\\] {\n    width: 550px;\n  }\n\n  .t2xl\\:w-\\[90\\%\\] {\n    width: 90%;\n  }\n\n  .t2xl\\:justify-center {\n    justify-content: center;\n  }\n\n  .t2xl\\:text-base {\n    font-size: 1rem;\n    line-height: 1.5rem;\n  }\n}\n\n@media (min-width: 2570px) {\n  .t3xl\\:absolute {\n    position: absolute;\n  }\n\n  .t3xl\\:left-52 {\n    left: 13rem;\n  }\n\n  .t3xl\\:left-96 {\n    left: 24rem;\n  }\n\n  .t3xl\\:top-8 {\n    top: 2rem;\n  }\n\n  .t3xl\\:top-\\[100px\\] {\n    top: 100px;\n  }\n\n  .t3xl\\:top-\\[108px\\] {\n    top: 108px;\n  }\n\n  .t3xl\\:top-\\[80px\\] {\n    top: 80px;\n  }\n\n  .t3xl\\:left-\\[8\\%\\] {\n    left: 8%;\n  }\n\n  .t3xl\\:top-\\[52px\\] {\n    top: 52px;\n  }\n\n  .t3xl\\:mb-4 {\n    margin-bottom: 1rem;\n  }\n\n  .t3xl\\:ml-4 {\n    margin-left: 1rem;\n  }\n\n  .t3xl\\:ml-40 {\n    margin-left: 10rem;\n  }\n\n  .t3xl\\:mt-10 {\n    margin-top: 2.5rem;\n  }\n\n  .t3xl\\:mt-16 {\n    margin-top: 4rem;\n  }\n\n  .t3xl\\:mt-2 {\n    margin-top: 0.5rem;\n  }\n\n  .t3xl\\:mt-4 {\n    margin-top: 1rem;\n  }\n\n  .t3xl\\:mt-6 {\n    margin-top: 1.5rem;\n  }\n\n  .t3xl\\:mt-8 {\n    margin-top: 2rem;\n  }\n\n  .t3xl\\:mb-12 {\n    margin-bottom: 3rem;\n  }\n\n  .t3xl\\:mt-24 {\n    margin-top: 6rem;\n  }\n\n  .t3xl\\:mt-44 {\n    margin-top: 11rem;\n  }\n\n  .t3xl\\:flex {\n    display: flex;\n  }\n\n  .t3xl\\:h-20 {\n    height: 5rem;\n  }\n\n  .t3xl\\:h-36 {\n    height: 9rem;\n  }\n\n  .t3xl\\:h-52 {\n    height: 13rem;\n  }\n\n  .t3xl\\:h-\\[280px\\] {\n    height: 280px;\n  }\n\n  .t3xl\\:h-\\[300px\\] {\n    height: 300px;\n  }\n\n  .t3xl\\:h-\\[400px\\] {\n    height: 400px;\n  }\n\n  .t3xl\\:h-\\[420px\\] {\n    height: 420px;\n  }\n\n  .t3xl\\:h-\\[450px\\] {\n    height: 450px;\n  }\n\n  .t3xl\\:h-\\[500px\\] {\n    height: 500px;\n  }\n\n  .t3xl\\:h-72 {\n    height: 18rem;\n  }\n\n  .t3xl\\:max-h-\\[500px\\] {\n    max-height: 500px;\n  }\n\n  .t3xl\\:w-36 {\n    width: 9rem;\n  }\n\n  .t3xl\\:w-52 {\n    width: 13rem;\n  }\n\n  .t3xl\\:w-\\[800px\\] {\n    width: 800px;\n  }\n\n  .t3xl\\:w-72 {\n    width: 18rem;\n  }\n\n  .t3xl\\:w-\\[1200px\\] {\n    width: 1200px;\n  }\n\n  .t3xl\\:w-\\[75\\%\\] {\n    width: 75%;\n  }\n\n  .t3xl\\:items-center {\n    align-items: center;\n  }\n\n  .t3xl\\:justify-center {\n    justify-content: center;\n  }\n\n  .t3xl\\:gap-56 {\n    gap: 14rem;\n  }\n\n  .t3xl\\:gap-20 {\n    gap: 5rem;\n  }\n\n  .t3xl\\:rounded-xl {\n    border-radius: 0.75rem;\n  }\n\n  .t3xl\\:pl-60 {\n    padding-left: 15rem;\n  }\n\n  .t3xl\\:text-3xl {\n    font-size: 1.875rem;\n    line-height: 2.25rem;\n  }\n\n  .t3xl\\:text-4xl {\n    font-size: 2.25rem;\n    line-height: 2.5rem;\n  }\n\n  .t3xl\\:text-5xl {\n    font-size: 3rem;\n    line-height: 1;\n  }\n\n  .t3xl\\:font-bold {\n    font-weight: 700;\n  }\n\n  .t3xl\\:leading-normal {\n    line-height: 1.5;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
